import {

  doc as firestoreDoc,
} from "firebase/firestore";
import React, { useCallback, useState, useEffect, useMemo   } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc,  getDocs, updateDoc } from "firebase/firestore";
import { collection,  addDoc, getDoc, Timestamp, serverTimestamp} from "firebase/firestore";
import { getStorage, listAll, getDownloadURL } from "firebase/storage";
import { ref, uploadBytes,  uploadBytesResumable, deleteObject } from 'firebase/storage'; // Modular imports
import { deleteDoc } from "firebase/firestore";
import { storage } from './firebase'; // Import storage from firebase.js
import { v4 as uuidv4 } from "uuid"; // Import uuid for generating unique IDs
import { query, where} from "firebase/firestore";
import * as XLSX from 'xlsx';  // Import the XLSX library

import { ref as storageRef } from "firebase/storage";
import { saveAs } from "file-saver";




import "./adminpanel.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Eye, EyeOff, Option } from "lucide-react";

const AdminPanel = () => {

  const [selectedOption, setSelectedOption] = useState("home"); // Default to "home"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [program, setProgram] = useState("");
  const [courseType, setCourseType] = useState("");
  const [courseFee, setCourseFee] = useState("");
  const [batch, setBatch] = useState("");
  const [address, setAddress] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fullName, setFullName] = useState("");
  const [nameWithInitial, setNameWithInitial] = useState("");
  const [nicPassport, setNicPassport] = useState("");
  const [contactNo, setContactNo] = useState("")
  const [nameToBeAppeared, setNameToBeAppeared] = useState("")

const [programFilter, setProgramFilter] = useState("");






// ✅ Define all states first

const [batchFilter, setBatchFilter] = useState("");   // <— IMPORTANT


const [filterCourse, setFilterCourse] = useState("");
const [filterBatch, setFilterBatch] = useState("");
const [filterModuleName, setFilterModuleName] = useState("");



//edit student
const [editingUser, setEditingUser] = useState(null); // To hold the selected user's data for editing


  const [assignments, setAssignments] = useState([]); // For storing fetched assignments

//google classroom link
const [googleclassroomLink, setGoogleClassroomLink] = useState("")

//upload study materials
const [includeFile, setIncludeFile] = useState(false);

  // Dropdown button for upload and update results
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!isUserDropdownOpen);
  };



  // Dropdown button for upload and update results
  const [isResultDropdownOpen, setResultDropdownOpen] = useState(false);
  const toggleResultDropdown = () => {
    setResultDropdownOpen(!isResultDropdownOpen);
  };



    // Dropdown button for Assignment management
  const [isAssignmentDropdownOpen, setAssignmentDropdownOpen] = useState(false);
  const toggleAssignmentDropdown = () => {
    setAssignmentDropdownOpen(!isAssignmentDropdownOpen);
  };


  
    // Dropdown button for Assignment management
  const [isLectureMaterialDropdownOpen, setLectureMaterialDropdownOpen] = useState(false);
  const toggleLectureMaterialDropdown = () => {
    setLectureMaterialDropdownOpen(!isLectureMaterialDropdownOpen);
  };



  //quiz master link create
  const [quizLink, setQuizLink] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [Test, setTest] = useState("");


  //lecture video recordings
  const [lectureRecordingLink, setLectureRecordingLink] = useState("")
  const [session,  setSession] = useState("")
 
    // State variables for form inputs for upload assignment brief
    const [issueDate, setIssueDate] = useState('');  // Define issueDate state
    const [submissionDate, setSubmissionDate] = useState('');  // Define submissionDate state
   

//pdf upload
const [selectedFile, setSelectedFile] = useState(null);



  const [users, setUsers] = useState([]); // State to store users
  const [groupedUsers, setGroupedUsers] = useState({}); // Users grouped by role


// assignment deadline link
const [submissionDeadline, setSubmissionDeadline] = useState("");
const [uploadLink, setUploadLink] = useState("");

//assignment brief upload only three times
const [uploadProgress, setUploadProgress] = useState(0);

//upload pdf
const [file, setFile] = useState(null);
const [id, setId] = useState('');


   // Error state initialization
  const [error, setError] = useState(null);  // Initialize the error state
  const [loading, setLoading] = useState(false);
  

//notice board
  const [subject, setSubject] = useState("");
  const [notice, setNotice] = useState("");
  const [addedDate, setAddedDate] = useState("");

//input course module
const [success, setSuccess] = useState(null);

const navigate = useNavigate();



//upload result
const [semester, setSemester] = useState('');
const [typeOfAssesment, setTypeOfAssesment] = useState('');
const [moduleCode, setModuleCode] = useState('');
const [moduleName, setModuleName] = useState('');
const [grade, setGrade] = useState('');


//PASSWORD VIEW
const [showPassword, setShowPassword] = useState(false);


//sarch user by name & batch
const [filteredUsers, setFilteredUsers] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const [searchOption, setSearchOption] = useState("name");


//student payment details tab
const [students, setStudents] = useState([]);
const [filteredStudents, setFilteredStudents] = useState([]);


//calculate total outstanding amount according to the batch & course
// State for dropdowns and data
const [outstandingPayments, setOutstandingPayments] = useState(0);

const [isSubmitted, setIsSubmitted] = useState(false); // To track if submit is clicked




//upload image in notice board
// Add these state variables at the top of your component
const [hasImage, setHasImage] = useState(false);
const [imageFile, setImageFile] = useState(null);
const [imageUrl, setImageUrl] = useState('');
const [isUploading, setIsUploading] = useState(false);


//search and filter for download users

  const [roleFilter, setRoleFilter] = useState("");
  const [summary, setSummary] = useState({});



//result overview
// ===================== STATE DEFINITIONS =====================
const [continuousAssessmentResults, setContinuousAssessmentResults] = useState([]);
const [practicalExamResults, setPracticalExamResults] = useState([]);
const [finalExamResults, setFinalExamResults] = useState([]);
const [assignmentResults, setAssignmentResults] = useState([]);

const [selectedStudent, setSelectedStudent] = useState(null);


const [searchName, setSearchName] = useState("");
const [searchRegNo, setSearchRegNo] = useState("");
const [selectedCourse, setSelectedCourse] = useState("");
const [selectedBatch, setSelectedBatch] = useState("");
  const [studentsList, setStudentsList] = useState([]);
  const [resultsList, setResultsList] = useState([]);







  // Logout function
  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  

  const createAccount = async () => {
    try {
      // Create user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;


      // Save user details in Firestore
      await setDoc(doc(db, "users", userId), {
        email,
        role,
        registrationNumber,
        program,
        courseType,
        courseFee,
        batch,
        address,
        firstName,
        lastName,
        fullName,
        nameWithInitial,
        nicPassport,
        contactNo,
        nameToBeAppeared,
      });



      alert("User created successfully!");
      // Reset the form
      setEmail("");
      setPassword("");
      setRole("");
      setRegistrationNumber("");
      setProgram("");
      setCourseType("");
      setCourseFee("");
      setBatch("");
      setAddress("");
      setFirstName("");
      setLastName("");
      setFullName("");
      setNameWithInitial("");
      setNicPassport("");
      setContactNo("");
      setNameToBeAppeared("");

    } catch (error) {
      console.error("Error creating user:", error.message);
      alert(error.message);
    }
  };




//create course module
  const [moduleData, setModuleData] = useState({
    id: "",
    moduleCode: "",
    moduleName: "",
    semester: "",
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setModuleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    // Validate if all required fields are filled
    if (
      !moduleData.semester ||
      !moduleData.moduleCode ||
      !moduleData.moduleName ||
      !moduleData.id
    ) {
      setError("Please fill all the fields.");
      setLoading(false);
      return;
    }
  
    try {
      // Add the module to Firestore
      const modulesRef = collection(db, "cmodule");
      await addDoc(modulesRef, moduleData);
      toast.success("✅ Module created successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
  
      // Reset form fields
      setModuleData({
        id: "",
        moduleCode: "",
        moduleName: "",
        semester: "",
      });
    } catch (err) {
      console.error("Error creating module:", err);
      setError("Failed to create module: " + err.message);
      toast.error("❌ Failed to create module: " + err.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//  // Snowflake generator
//  useEffect(() => {
//   const createSnowflake = () => {
//     const snowflake = document.createElement("div");
//     snowflake.className = "snowflake";
//     snowflake.style.left = Math.random() * 100 + "vw";
//     snowflake.style.animationDuration = Math.random() * 3 + 2 + "s"; // Varying speed
//     snowflake.style.opacity = Math.random(); // Varying opacity
//     document.body.appendChild(snowflake);

//     setTimeout(() => {
//       snowflake.remove();
//     }, 5000); // Remove snowflake after animation
//   };

//   const interval = setInterval(createSnowflake, 100); // Create a snowflake every 100ms
//   return () => clearInterval(interval); // Cleanup interval on unmount
// }, []);







////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// useEffect(() => {
//   if (selectedOption === "viewAllUsers") {
//     fetchAllUsers();
//   }
// }, [selectedOption]);

// // // Fetch all users from Firestore
// // const fetchAllUsers = async () => {
// //   try {
// //     const querySnapshot = await getDocs(collection(db, "users"));
// //     const userList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

// //     // Group users by role
// //     const grouped = userList.reduce((acc, user) => {
// //       if (!acc[user.role]) acc[user.role] = [];
// //       acc[user.role].push(user);
// //       return acc;
// //     }, {});

// //     setUsers(userList);
// //     setGroupedUsers(grouped);
// //   } catch (error) {
// //     console.error("Error fetching users:", error.message);
// //     alert("Failed to fetch users.");
// //   }
// // };

// const renderUsersByrole = () => {
//   return Object.keys(groupedUsers).map((role) => (
//     <div key={role} className="user-group">
//       <h2 className="role-title">{role.charAt(0).toUpperCase() + role.slice(1)}s</h2>
//       <table className="user-table">
//         <thead>
//           <tr>
//             <th>Full Name</th>
//             <th>Email</th>
//             <th>Contact Number</th>
//             <th>Program</th>
//             <th>Registration Number</th>
//           </tr>
//         </thead>
//         <tbody>
//           {groupedUsers[role].map((user) => (
//             <tr key={user.id}>
//               <td>{user.fullName}</td>
//               <td>{user.email}</td>
//               <td>{user.contactNo}</td>
//               <td>{user.program}</td>
//               <td>{user.registrationNumber}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   ));
// };
  
























// // Fetch users when "Manage Users" is selected
useEffect(() => {
  if (selectedOption === "manageUsers") {
    fetchUsers();
  }
}, [selectedOption]);

const fetchUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const usersData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    console.log("Fetched Users:", usersData);
    setUsers(usersData);
    groupAndSetUsers(usersData);
  } catch (error) {
    console.error("Error fetching users:", error.message);
  }
};

// Group users by role with normalization + search filter
const groupAndSetUsers = (usersData) => {
  const normalizedUsers = usersData.map((user) => ({
    ...user,
    role: user.role?.toLowerCase() || "unknown",
  }));

  const filtered = normalizedUsers.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      user.fullName?.toLowerCase().includes(query) ||
      user.registrationNo?.toLowerCase().includes(query) ||
      user.email?.toLowerCase().includes(query)
    );
  });

  const grouped = filtered.reduce((acc, user) => {
    if (!acc[user.role]) acc[user.role] = [];
    acc[user.role].push(user);
    return acc;
  }, {});

  // Sort roles: admin -> others -> unknown
  const sorted = Object.keys(grouped)
    .sort((a, b) => (a === "admin" ? -1 : b === "admin" ? 1 : 0))
    .reduce((acc, key) => {
      acc[key] = grouped[key];
      return acc;
    }, {});

  setGroupedUsers(sorted);
};

useEffect(() => {
  groupAndSetUsers(users);
}, [searchQuery, users]);

// Remove user (any role allowed)
const removeUser = async (userId) => {
  if (!window.confirm("Are you sure you want to remove this user?")) return;

  try {
    await deleteDoc(doc(db, "users", userId));
    alert("✅ User removed successfully!");
    setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
  } catch (error) {
    console.error("Error removing user:", error.message);
    alert("⚠️ Failed to remove user. Please try again.");
  }
};

// Render Users
const renderUsersByRole = () => {
  return Object.entries(groupedUsers).map(([role, users]) => (
    <div key={role} className="user-role-group">
      <h2>
        {role === "unknown"
          ? "No Role Assigned"
          : role.charAt(0).toUpperCase() + role.slice(1)}
      </h2>
      <ul>
        {users.map((user) => (
          <li key={user.id} className="user-item">
            <span>
              {user.fullName || "Unnamed"} ({user.email}) -{" "}
              {user.registrationNo || "."}
            </span>

            <button
              className="remove-user-button"
              onClick={() => removeUser(user.id)}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  ));
};

// useEffect(() => {
//   if (selectedOption === "manageUsers") {
//     fetchUsers();
//   }
// }, [selectedOption]);

// const fetchUsers = async () => {
//   try {
//     const querySnapshot = await getDocs(collection(db, "users"));
//     const usersData = querySnapshot.docs.map((doc) => ({
//       id: doc.id, // User ID
//       ...doc.data(), // User data
//     }));

//     setUsers(usersData);
//     groupAndSetUsers(usersData);
//   } catch (error) {
//     console.error("Error fetching users:", error.message);
//   }
// };

// // Group users by role (after applying search filter)
// const groupAndSetUsers = (usersData) => {
//   // Filter first by search query
//   const filtered = usersData.filter((user) => {
//     const query = searchQuery.toLowerCase();
//     return (
//       user.fullName?.toLowerCase().includes(query) ||
//       user.registrationNo?.toLowerCase().includes(query) // assuming registrationNo field exists
//     );
//   });

//   // Group by role
//   const grouped = filtered.reduce((acc, user) => {
//     if (!acc[user.role]) acc[user.role] = [];
//     acc[user.role].push(user);
//     return acc;
//   }, {});
//   setGroupedUsers(grouped);
// };

// // Update search filter dynamically
// useEffect(() => {
//   groupAndSetUsers(users);
// }, [searchQuery, users]);

// // Remove a user by ID
// const removeUser = async (userId) => {
//   try {
//     await deleteDoc(doc(db, "users", userId));
//     alert("User removed successfully!");
//     setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
//   } catch (error) {
//     console.error("Error removing user:", error.message);
//     alert("Failed to remove user. Please try again.");
//   }
// };

// // Render users grouped by role
// const renderUsersByRole = () => {
//   return Object.entries(groupedUsers).map(([role, users]) => (
//     <div key={role} className="user-role-group">
//       <h2>{role.charAt(0).toUpperCase() + role.slice(1)}</h2>
//       <ul>
//         {users.map((user) => (
//           <li key={user.id} className="user-item">
//             <span>
//               {user.fullName} ({user.email}) - {user.registrationNo}
//             </span>
//             <button
//               className="remove-user-button"
//               onClick={() => removeUser(user.id)}
//             >
//               Remove
//             </button>
//           </li>
//         ))}
//       </ul>
//     </div>
//   ));
// };




/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

useEffect(() => {
  if (selectedOption === "manageUsers") {
    fetchAllUsersForDownload();
  }
}, [selectedOption]);

const fetchAllUsersForDownload = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const userList = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const grouped = userList.reduce((acc, user) => {
      if (!acc[user.role]) acc[user.role] = [];
      acc[user.role].push(user);
      return acc;
    }, {});

    setUsers(userList);
    setGroupedUsers(grouped);
    updateSummary(grouped);
  } catch (error) {
    console.error("Error fetching users:", error.message);
    alert("Failed to fetch users.");
  }
};

const updateSummary = (grouped) => {
  const summaryCounts = {
    students: grouped.student ? grouped.student.length : 0,
    lecturers: grouped.lecturer ? grouped.lecturer.length : 0,
    admins: grouped.admin ? grouped.admin.length : 0,
    subAdmins: grouped.subAdmin ? grouped.subAdmin.length : 0,
    total: Object.values(grouped).reduce((sum, arr) => sum + arr.length, 0),
  };
  setSummary(summaryCounts);
};

// Helper: extract batch (YYYY-MM) from registration number
const extractBatchFromRegNo = (regNo = "") => {
  const match = regNo.match(/(\d{4}-\d{2})/);
  return match ? match[1] : "";
};

// Get unique batches
const uniqueBatches = [
  ...new Set(
    users
      .map((user) => extractBatchFromRegNo(user.registrationNumber))
      .filter(Boolean)
  ),
];

// Get unique programs
const uniquePrograms = [
  ...new Set(users.map((user) => user.program).filter(Boolean)),
];

// Get unique roles
const uniqueRoles = [
  ...new Set(users.map((user) => user.role).filter(Boolean)),
];

// CORRECTED: Count users based on current filters
const getFilteredCounts = () => {
  const currentFilteredUsers = users.filter((user) => {
    const matchesSearch =
      searchQuery === "" ||
      (searchOption === "name" &&
        user.fullName?.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (searchOption === "registrationNumber" &&
        user.registrationNumber
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()));

    const matchesBatch =
      batchFilter === "" || 
      extractBatchFromRegNo(user.registrationNumber) === batchFilter;

    const matchesProgram =
      programFilter === "" || user.program === programFilter;

    const matchesRole = roleFilter === "" || user.role === roleFilter;

    return matchesSearch && matchesBatch && matchesProgram && matchesRole;
  });

  // Count for batch filter (considering all other active filters)
  const batchCount = batchFilter
    ? currentFilteredUsers.filter(
        (user) => extractBatchFromRegNo(user.registrationNumber) === batchFilter
      ).length
    : currentFilteredUsers.length;

  // Count for program filter (considering all other active filters)
  const programCount = programFilter
    ? currentFilteredUsers.filter((user) => user.program === programFilter).length
    : currentFilteredUsers.length;

  return {
    totalFiltered: currentFilteredUsers.length,
    batchCount,
    programCount
  };
};

// Filter users by search, batch, program, and role
const filteredUsersForDownload = users.filter((user) => {
  const matchesSearch =
    searchQuery === "" ||
    (searchOption === "name" &&
      user.fullName?.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (searchOption === "registrationNumber" &&
      user.registrationNumber
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase()));

  const matchesBatch =
    batchFilter === "" || 
    extractBatchFromRegNo(user.registrationNumber) === batchFilter;

  const matchesProgram =
    programFilter === "" || user.program === programFilter;

  const matchesRole = roleFilter === "" || user.role === roleFilter;

  return matchesSearch && matchesBatch && matchesProgram && matchesRole;
});

const downloadFilteredUsersData = () => {
  const exportData = filteredUsersForDownload.map((user) => ({
    registrationNumber: user.registrationNumber || "",
    nameWithInitial: user.nameWithInitial || "",
    batch: user.registrationNumber?.substring(0, 7) || "",
    program: user.program || "",
    courseType: user.courseType || "",
    email: user.email || "",
    contactNo: user.contactNo || "",
    address: user.address || "",
    nicPassport: user.nicPassport || "",
  }));

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Users");
  XLSX.writeFile(wb, "Filtered_Users.xlsx");
};

const renderFilteredUsersTable = () => {
  return (
    <table className="user-table">
      <thead>
        <tr>
          <th>Registration No</th>
          <th>Name With Initial</th>
          <th>Batch</th>
          <th>Program</th>
          <th>Course Type</th>
          <th>Email</th>
          <th>Contact No</th>
          <th>Address</th>
          <th>NIC / Passport</th>
          <th>Role</th>
        </tr>
      </thead>
      <tbody>
        {filteredUsersForDownload.map((user) => (
          <tr key={user.id}>
            <td>{user.registrationNumber}</td>
            <td>{user.nameWithInitial}</td>
            <td>{user.registrationNumber?.substring(0, 7)}</td>
            <td>{user.program}</td>
            <td>{user.courseType}</td>
            <td>{user.email}</td>
            <td>{user.contactNo}</td>
            <td>{user.address}</td>
            <td>{user.nicPassport}</td>
            <td>{user.role}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};





















































// Update your createNotice function
const createNotice = async () => {
  if (!subject || !notice || !addedDate) {
    toast.error("❌ All fields are required!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    return;
  }

  setIsUploading(true);

  try {
    const noticeData = {
      subject: subject,
      notice: notice,
      addedDate: Timestamp.fromDate(new Date(addedDate)),
      hasImage: hasImage,
    };

    // If image is included, upload it first
    if (hasImage && imageFile) {
      const storageRef = ref(storage, `notices/${Date.now()}_${imageFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, imageFile);
      
      // Wait for upload to complete
      await uploadTask;
      
      // Get download URL
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      noticeData.imageUrl = downloadURL;
    }

    // Save notice to Firestore
    await addDoc(collection(db, "notices"), noticeData);

    toast.success("✅ Notice created successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

    // Clear all fields after success
    setSubject("");
    setNotice("");
    setAddedDate("");
    setHasImage(false);
    setImageFile(null);
    setImageUrl("");
  } catch (error) {
    console.error("Error adding notice: ", error);
    toast.error("❌ Failed to create notice. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } finally {
    setIsUploading(false);
  }
};




/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//upload results
const [remark, setRemark] = useState("");
const [date, setDate] = useState("");
const [attemptNo, setAttemptNo] = useState("1st"); // Default to "1st" if not provided


const uploadResults = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const resultsCollection = collection(db, "results");
    await addDoc(resultsCollection, {
      semester,
      date,
      attemptNo: attemptNo || "1st", // Default to "1st" if not provided
      typeOfAssesment,
      registrationNumber,
      program,
      batch,
      moduleCode,
      moduleName,
      grade,
      remark,
    });

    toast.success("✅ Result uploaded successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

    // Reset form fields
    setSemester("");
    setDate("");
    setAttemptNo("1st"); // Reset attempt number to 1
    setTypeOfAssesment("");
    setRegistrationNumber("");
    setProgram("");
    setBatch("");
    setModuleCode("");
    setModuleName("");
    setGrade("");
    setRemark("");

  } catch (error) {
    console.error("Error uploading result:", error);
    toast.error("❌ Failed to upload the result. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } finally {
    setLoading(false);
  }
};







//upload lecture materials pdf
  // // Handle file selection
  // const handleFileSelect = (e) => {
  //   const file = e.target.files[0];
  //   if (file && file.type === "application/pdf") {
  //     setSelectedFile(file);
  //     setError('');
  //   } else {
  //     setError("Please select a valid PDF file.");
  //   }
  // };

  // Handle file selection
const handleFileSelect = (e) => {
  const file = e.target.files[0];

  // Allow PDF, PPT, PPTX
  const allowedTypes = [
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ];

  if (file && allowedTypes.includes(file.type)) {
    setSelectedFile(file);
    setError('');
  } else {
    setError("Please select a valid PDF or PPT/PPTX file.");
  }
};





const uploadFile = async (e) => {
  e.preventDefault();

  if (!selectedFile) {
    setError("No file selected.");
    return;
  }

  if (!batch || !id || !moduleCode || !moduleName) {
    setError("Please fill in all the fields.");
    return;
  }

  setLoading(true);

  try {
    const uniqueFileName = `${uuidv4()}_${selectedFile.name}`;

    const storageRef = ref(storage, `materials/${uniqueFileName}`);
    await uploadBytes(storageRef, selectedFile);

    const fileUrl = await getDownloadURL(storageRef);

    await addDoc(collection(db, "materials"), {
      batch,
      id,
      moduleCode,
      moduleName,
      fileUrl,
      fileType: selectedFile.type,
      uploadedAt: new Date()
    });

    setLoading(false);
    alert("File uploaded successfully!");
  } catch (err) {
    console.error("Upload error:", err);
    setError(`Error uploading file: ${err.message || err}`);
    setLoading(false);
  }
};


  // // Handle form submission and file upload
  // const uploadFile = async (e) => {
  //   e.preventDefault();

  //   if (!selectedFile) {
  //     setError("No file selected.");
  //     return;
  //   }

  //   if (!batch || !id || !moduleCode || !moduleName) {
  //     setError("Please fill in all the fields.");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     // Generate a unique file name using UUID
  //     const uniqueFileName = `${uuidv4()}_${selectedFile.name}`;

  //     // Upload the file to Firebase Storage with a unique file name
  //     const storageRef = ref(storage, `pdfs/${uniqueFileName}`);
  //     await uploadBytes(storageRef, selectedFile);

  //     // Get the download URL
  //     const fileUrl = await getDownloadURL(storageRef);
  //     console.log("File uploaded successfully:", fileUrl);

  //     // Optionally, store the file URL and other data in Firestore
  //     // Store multiple PDFs under the same 'id' using addDoc to create a new document each time
  //     await addDoc(collection(db, "materials"), {
  //       batch,
  //       id,
  //       moduleCode,
  //       moduleName,
  //       fileUrl,
  //     });

  //     setLoading(false);
  //     alert("File uploaded successfully!");
  //   } catch (err) {
  //     console.error("Upload error:", err);
  //     setError(`Error uploading file: ${err.message || err}`);
  //     setLoading(false);
  //   }
  // };








//upload assignment  brief
// Handle form submission and file upload
const uploadAssignmnt = async (e) => {
  e.preventDefault();

  if (!selectedFile) {
    setError("No file selected.");
    return;
  }

  if (!batch || !id || !moduleCode || !moduleName || !issueDate || !submissionDate) {
    setError("Please fill in all the fields.");
    return;
  }

  if (new Date(issueDate) > new Date(submissionDate)) {
    setError("Issue Date cannot be later than Submission Date.");
    return;
  }

  setLoading(true);
  setUploadProgress(0);

  try {
    const fileName = `${selectedFile.name}-${new Date().getTime()}`;
    const storageRef = ref(storage, `pdfs/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, selectedFile);

    // Track progress
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        console.error("Error uploading file:", error);
        setError("Failed to upload file.");
        setLoading(false);
      },
      async () => {
        const fileUrl = await getDownloadURL(uploadTask.snapshot.ref);
        console.log("Assignment uploaded successfully:", fileUrl);

        const assignmentDocRef = doc(db, "assignments", `${id}-${new Date().getTime()}`);

        await setDoc(assignmentDocRef, {
          batch,
          id,
          moduleCode,
          moduleName,
          issueDate,
          submissionDate,
          fileUrl,
        });

        setLoading(false);
        setUploadProgress(0);
        alert("Assignment uploaded successfully!");

        // Clear form fields
        setBatch("");
        setId("");
        setModuleCode("");
        setModuleName("");
        setIssueDate("");
        setSubmissionDate("");
        setSelectedFile(null);
      }
    );
  } catch (err) {
    console.error("Upload error:", err);
    setError(`Error uploading file: ${err.message || err}`);
    setLoading(false);
    setUploadProgress(0);
  }
};

const handleAssignmentChange = (e) => {
  const file = e.target.files[0];
  if (file && file.type === "application/pdf") {
    setSelectedFile(file); // Ensure `setSelectedFile` is defined in your state
    setError(""); // Optional: Clear any previous errors
  } else {
    setError("Please select a valid PDF file.");
  }
};





//update student payments
const [formData, setFormData] = useState({
  registrationNumber: "",
  paymentDate: "",
  receiptNo: "",
  paymentType: "",
  amount: "",
  remark: "",
});


// Handle input changes
const paymentChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
};

// Handle form submission
const paymentSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");

  try {
    await addDoc(collection(db, "payments"), {
      ...formData,
      paymentDate: formData.paymentDate ? new Date(formData.paymentDate) : serverTimestamp(), // Use selected payment date, or fallback to server timestamp
      amount: parseInt(formData.amount), // Ensure amount is a number
    });
    setSuccess("Payment data submitted successfully!");
    setFormData({
      registrationNumber: "",
      paymentDate: "",
      receiptNo: "",
      paymentType: "",
      amount: "",
      remark: "",
    });
  } catch (err) {
    setError("Error submitting data: " + err.message);
  }
};











// //create assignment deadline link
const handleCreateAssignment = async () => {
  if (!moduleName || !moduleCode || !submissionDeadline || !batch || !id) {
    alert("All fields are required!");
    return;
  }

  try {
    setLoading(true);

    // Convert submissionDeadline to a timestamp
    const deadlineTimestamp = new Date(submissionDeadline).getTime();

    // Generate the upload link
    const uploadLink = `assignments/${id}_${batch}_${deadlineTimestamp}`;

    // Add the assignment details to the Firestore collection
    await addDoc(collection(db, "assignmentSubmissionDetails"), {
      id,
      batch,
      moduleName,
      moduleCode,
      submissionDeadline: new Date(submissionDeadline),
      uploadLink, // Include the generated upload link
    });

    alert("Assignment deadline created successfully!");
    
    // Clear form fields after successful creation
    setBatch("");
    setId("");
    setModuleName("");
    setModuleCode("");
    setSubmissionDeadline("");

  } catch (error) {
    console.error("Error creating assignment:", error);
    alert("Failed to create assignment. Try again.");
  } finally {
    setLoading(false);
  }
};




//create assignment deadline link for mitigate student//////////////////////////////////////////////////////////////////////////////////
// //create assignment deadline link
const handleCreateAssignmentForMitigate = async () => {
  if (!moduleName || !moduleCode || !submissionDeadline || !batch || !id) {
    alert("All fields are required!");
    return;
  }

  try {
    setLoading(true);

    // Convert submissionDeadline to a timestamp
    const deadlineTimestamp = new Date(submissionDeadline).getTime();

    // Generate the upload link
    const uploadLink = `assignments/${id}_${batch}_${deadlineTimestamp}`;

    // Add the assignment details to the Firestore collection
    await addDoc(collection(db, "assignmentSubmissionDetails"), {
      id,
      registrationNumber,
      batch,
      moduleName,
      moduleCode,
      submissionDeadline: new Date(submissionDeadline),
      uploadLink, // Include the generated upload link
    });

    alert("Assignment deadline created successfully!");
    
    // Clear form fields after successful creation
    setBatch("");
    setId("");
    setModuleName("");
    setModuleCode("");
    setSubmissionDeadline("");

  } catch (error) {
    console.error("Error creating assignment:", error);
    alert("Failed to create assignment. Try again.");
  } finally {
    setLoading(false);
  }
};




// Fetch all users when the option is selected
useEffect(() => {
  if (selectedOption === "viewAllUsers") {
    fetchAllUsers();
  }
}, [selectedOption]);

// Fetch all users from Firestore
const fetchAllUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const userList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    // Group users by role
    const grouped = userList.reduce((acc, user) => {
      if (!acc[user.role]) acc[user.role] = [];
      acc[user.role].push(user);
      return acc;
    }, {});

    setUsers(userList);
    setFilteredUsers(userList); // Initialize filtered users
    setGroupedUsers(grouped);
  } catch (error) {
    console.error("Error fetching users:", error.message);
    alert("Failed to fetch users.");
  }
};



// Function to download all user details as an Excel file (.xlsx)
const downloadUsers = () => {
  try {
    // Create a worksheet from the users array
    const ws = XLSX.utils.json_to_sheet(users);
    
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Users');
    
    // Write the workbook to an Excel file and trigger the download
    XLSX.writeFile(wb, 'users.xlsx');
  } catch (error) {
    console.error('Error generating Excel file:', error);
    alert('Failed to generate Excel file.');
  }
};





// Search functionality
useEffect(() => {
  if (searchQuery.trim() === "") {
    setFilteredUsers(users);
  } else {
    const filtered = users.filter((user) => {
      if (searchOption === "name") {
        return user.fullName?.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchOption === "registrationNumber") {
        return user.registrationNumber?.toLowerCase().includes(searchQuery.toLowerCase());
      }
      return false;
    });
    setFilteredUsers(filtered);
  }
}, [searchQuery, searchOption, users]);


// Render filtered users by role
const renderFilteredUsers = () => {
  const grouped = filteredUsers.reduce((acc, user) => {
    if (!acc[user.role]) acc[user.role] = [];
    acc[user.role].push(user);
    return acc;
  }, {});

  return Object.keys(grouped).map((role) => (
    <div key={role} className="user-group">
      <h2 className="role-title">{role.charAt(0).toUpperCase() + role.slice(1)}s</h2>
      <table className="user-table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Contact Number</th>
            <th>Program</th>
            <th>Course Type</th>
            <th>Registration Number</th>
            
          </tr>
        </thead>
        <tbody>
          {grouped[role].map((user) => (
            <tr key={user.id}>
              <td>{user.fullName}</td>
              <td>{user.email}</td>
              <td>{user.contactNo}</td>
              <td>{user.program}</td>
              <td>{user.courseType}</td>
              <td>{user.registrationNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ));
};








{/*******************************************************************************************************/}


// Function to fetch outstanding payments when submit is clicked
const fetchOutstandingPayments = async () => {
  try {
    if (!courseType || !batch) return; // Don't run if no selection

    // Determine prefix from course type
    // const prefix = courseType === "Certificate in Optician" ? "CO-" : "DO-";

let prefix = "";

if (courseType === "Certificate in Optician") {
  prefix = "CO-";
} else if (courseType === "Certificate in Ophthalmic Optician") {
  prefix = "COO-";
} else if (courseType === "Diploma in Optometry") {
  prefix = "DO-";
}




    // Fetch all users from the selected batch and course type
    const usersQuery = query(
      collection(db, "users"),
      where("registrationNumber", ">=", prefix), 
      where("registrationNumber", "<", prefix + "\uf8ff"),
      where("batch", "==", batch)
    );

    const usersSnapshot = await getDocs(usersQuery);
    if (usersSnapshot.empty) {
      setOutstandingPayments(0);
      return;
    }

    const registrationNumbers = usersSnapshot.docs.map((doc) => doc.data().registrationNumber);

    let totalOutstanding = 0;

    // Loop through each registration number to calculate outstanding
    for (const regNo of registrationNumbers) {
      // Fetch payments for this registration number
      const paymentsQuery = query(
        collection(db, "payments"),
        where("registrationNumber", "==", regNo)
      );

      const paymentsSnapshot = await getDocs(paymentsQuery);
      
      // Calculate total paid
      let totalPaid = 0;
      paymentsSnapshot.forEach((doc) => {
        const payment = doc.data();
        totalPaid += payment.amount;
      });

      // Fetch course fee from user document
      const userDoc = usersSnapshot.docs.find((doc) => doc.data().registrationNumber === regNo);
      const courseFee = userDoc?.data().courseFee || 0;

      // Calculate outstanding amount for this student
      const outstandingAmount = courseFee - totalPaid;
      totalOutstanding += outstandingAmount;
    }

    setOutstandingPayments(totalOutstanding);
  } catch (error) {
    console.error("Error fetching outstanding payments: ", error);
  }
};

const handlePaymentSubmit = () => {
  setIsSubmitted(true); // Mark the form as submitted
  fetchOutstandingPayments(); // Trigger fetching outstanding payments
};



const handleClear = () => {
  setCourseType(""); // Reset course type
  setBatch(""); // Reset batch
  setOutstandingPayments(0); // Reset outstanding payments
  setIsSubmitted(false); // Reset submission state
};







const [courseFilter, setCourseFilter] = useState(""); 

  // Search & filters

  // 🔹payment details,  Fetch students with payments
  const fetchAllStudentsWithPayments = useCallback(async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"));
      const studentList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const studentsWithPayments = await Promise.all(
        studentList.map(async (student) => {
          if (!student.registrationNumber) return null;

          const paymentQuery = query(
            collection(db, "payments"),
            where("registrationNumber", "==", student.registrationNumber)
          );
          const paymentSnapshot = await getDocs(paymentQuery);

          let totalPaid = 0;
          let paymentsList = [];

          paymentSnapshot.forEach((doc) => {
            const payment = doc.data();
            paymentsList.push({ id: doc.id, ...payment });
            totalPaid += payment.amount;
          });

          // ✅ Sort payments by date (latest → oldest)
          paymentsList.sort((a, b) => {
            const dateA = a.paymentDate?.toDate
              ? a.paymentDate.toDate()
              : new Date(0);
            const dateB = b.paymentDate?.toDate
              ? b.paymentDate.toDate()
              : new Date(0);
            return dateB - dateA;
          });

          const courseFee = student.courseFee || 0;
          const outstandingAmount = courseFee - totalPaid;

          return {
            ...student,
            payments: paymentsList,
            totalPaid,
            outstandingAmount,
          };
        })
      );

      const validStudents = studentsWithPayments.filter((s) => s !== null);
      setStudents(validStudents);
      setFilteredStudents(validStudents);
    } catch (error) {
      console.error("Error fetching students with payments: ", error);
    }
  }, []);

  useEffect(() => {
    fetchAllStudentsWithPayments();
  }, [fetchAllStudentsWithPayments]);

  // 🔹 Helper: extract course from registration number
  const getAlphaPrefixDownload = (regNo = "") =>
    regNo.toString().toLowerCase().replace(/[^a-z]/g, "").slice(0, 2);




// ✅ Extract batch from registration number
const getBatchFromRegNoDownload = (regNo = "") => {
  const match = regNo.match(/(\d{4}-\d{2})/);
  return match ? match[1] : "";
};

// ✅ Always compute from ALL students
useEffect(() => {
  if (!students || students.length === 0) return;

  const allBatches = [
    ...new Set(
      students
        .map((s) => getBatchFromRegNoDownload(s.registrationNumber || ""))
        .filter(Boolean)
    ),
  ].sort();

  setAvailableBatches((prev) => {
    // if current selection is missing, reset to ""
    if (batchFilter && !allBatches.includes(batchFilter)) {
      setBatchFilter("");
    }
    return allBatches;
  });
}, [students, batchFilter]);






  // 🔹 Combined filter: search + course dropdown + batch dropdown
  useEffect(() => {
    let filtered = [...students];
    const q = searchQuery.trim().toLowerCase();

    // 1) Search filter
    if (q) {
      if (searchOption === "name") {
        filtered = filtered.filter((s) =>
          (s.fullName || "").toLowerCase().includes(q)
        );
      } else if (searchOption === "registrationNumber") {
        filtered = filtered.filter((s) =>
          (s.registrationNumber || "").toLowerCase().includes(q)
        );
      }
    }

    // 2) Course filter
    if (courseFilter) {
      const cf = courseFilter.toLowerCase();
      filtered = filtered.filter(
        (s) => getAlphaPrefixDownload(s.registrationNumber || "") === cf
      );
    }

    // 3) Batch filter
    if (batchFilter) {
      filtered = filtered.filter(
        (s) => getBatchFromRegNoDownload(s.registrationNumber || "") === batchFilter
      );
    }

    setFilteredStudents(filtered);
  }, [searchQuery, searchOption, courseFilter, batchFilter, students]);

  // 🔹 Handlers
  const handleCourseFilterChange = (e) => setCourseFilter(e.target.value);
  const handleBatchFilterChange = (e) => setBatchFilter(e.target.value);





// Handle search input change
const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle search option change (by name or registration number)
const handleSearchOptionChange = (e) => {
  setSearchOption(e.target.value);
};





// Add this delete function near your other functions
const deletePayment = async (paymentId) => {
  if (!window.confirm("Are you sure you want to delete this payment?")) {
    return;
  }
  
  try {
    await deleteDoc(doc(db, "payments", paymentId));
    fetchAllStudentsWithPayments(); // Refresh the data
    alert("Payment deleted successfully");
  } catch (error) {
    console.error("Error deleting payment: ", error);
    alert("Failed to delete payment");
  }
};

// // Download all payments in Excel
// const downloadPaymentsExcel = () => {
//   const allPayments = [];

//   students.forEach((student) => {
//     student.payments.forEach((payment) => {
//       allPayments.push({
//         "Student ID": student.registrationNumber || "N/A",
//         "Student Name": student.fullName || "N/A",
//         "Receipt No": payment.receiptNo || "N/A",
//         "Amount": payment.amount || 0,
//         "Payment Date": payment.paymentDate?.toDate().toLocaleDateString() || "N/A",
//         "Total Paid": student.totalPaid || 0,
//         "Outstanding Amount": student.outstandingAmount || 0,
//       });
//     });
//   });

//   const worksheet = XLSX.utils.json_to_sheet(allPayments);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

//   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   const data = new Blob([excelBuffer], { type: "application/octet-stream" });
//   saveAs(data, "Student_Payments.xlsx");
// };


// Download filtered payments in Excel
const downloadPaymentsExcel = () => {
  const allPayments = [];

  filteredStudents.forEach((student) => {
    student.payments.forEach((payment) => {
      allPayments.push({
        "Student ID": student.registrationNumber || "N/A",
        "Student Name": student.fullName || "N/A",
        "Receipt No": payment.receiptNo || "N/A",
        "Amount": payment.amount || 0,
        "Payment Date": payment.paymentDate?.toDate().toLocaleDateString() || "N/A",
        "Total Paid": student.totalPaid || 0,
        "Outstanding Amount": student.outstandingAmount || 0,
      });
    });
  });

  if (allPayments.length === 0) {
    alert("No payment records found for the selected filters.");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(allPayments);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Payments");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "Filtered_Student_Payments.xlsx");
};










//upload quiz master link
// Handle form submission
const uploadQuizLink = async (e) => {
  e.preventDefault();

  if (!courseType || !quizLink) {
    setErrorMessage("Please fill in both fields.");
    return;
  }

  try {
    // Saving the link and courseType to the Firestore collection "quizMaster"
    await addDoc(collection(db, "quizMaster"), {
      courseType,
      quizLink,
      moduleName,
      Test,
      createdAt: new Date(),
    });
    setSuccessMessage("Quiz Master link uploaded successfully!");
    setQuizLink(""); // Reset quiz link
    setCourseType(""); // Reset course type
    setModuleName("")
    setTest("")
  } catch (error) {
    setErrorMessage("Error uploading quiz link: " + error.message);
  }
};





const [part, setPart] = useState("");

//upload lecture Recording Link
// Handle form submission
const uploadRecordingLink = async (e) => {
  e.preventDefault();

if (
  !courseType?.trim() ||
  !moduleName?.trim() ||
  !batch?.trim() ||
  !session?.trim() ||
  !part?.trim() ||
  !lectureRecordingLink?.trim()
) {
  setErrorMessage("Please fill in all fields.");
  return;
}



  try {
    // Saving the link and courseType to the Firestore collection "quizMaster"
await addDoc(collection(db, "lectureRecordings"), {
  courseType,
  moduleName,
  batch,
  session,        // Session 01
  part,           // Part 01
  lectureRecordingLink,
  createdAt: new Date(),
});

    setSuccessMessage("Lecture Recording link uploaded successfully!");
    setLectureRecordingLink(""); // Reset quiz link
    setCourseType(""); // Reset course type
    setModuleName("")
    setTest("")
    setPart("");
  } catch (error) {
    setErrorMessage("Error uploading quiz link: " + error.message);
  }
};



/************************* upload study materials and google classromm link *************************************************/

//upload google classroom link
// // Handle form submission
// const uploadGoogleClassroomLink = async (e) => {
//   e.preventDefault();

//   if (!courseType || !googleclassroomLink) {
//     setErrorMessage("Please fill in both fields.");
//     return;
//   }

//   try {
//     // Saving the link and courseType to the Firestore collection "quizMaster"
//     await addDoc(collection(db, "googleclassroom"), {
//       courseType,
//       googleclassroomLink,
//       createdAt: new Date(),
//     });
//     setSuccessMessage("Google Classroom link uploaded successfully!");
//     setGoogleClassroomLink(""); // Reset link
//     setCourseType(""); // Reset course type
//   } catch (error) {
//     setErrorMessage("Error uploading quiz link: " + error.message);
//   }
// };
const uploadGoogleClassroomLink = async (e) => {
  e.preventDefault();
  setSuccessMessage("");
  setErrorMessage("");

  try {
    let fileUrl = "";

    // If file is included, upload to storage
    if (includeFile && selectedFile) {
      const fileName = `${Date.now()}_${selectedFile.name}`;
      const storageRef = ref(storage, `materials/${fileName}`);
      await uploadBytes(storageRef, selectedFile);
      fileUrl = await getDownloadURL(storageRef);
    }

    // Save to Firestore
    await addDoc(collection(db, "googleclassroom"), {
      courseType,
      moduleName,
      googleclassroomLink,
      fileUrl: fileUrl || null,
      includeFile,
      createdAt: new Date(),
    });

    setSuccessMessage("Uploaded successfully!");
    setGoogleClassroomLink("");
    setCourseType("");
    setModuleName("");
    setSelectedFile(null);
    setIncludeFile(false);

  } catch (error) {
    setErrorMessage("Error: " + error.message);
  }
};










//edit / update students

// Fetch students with proper registration number handling
const fetchStudents = async () => {
  try {
    const usersCollection = collection(db, "users");
    const usersSnapshot = await getDocs(usersCollection);
    
    const usersList = usersSnapshot.docs.map(doc => {
      const data = doc.data();
      // Ensure registrationNumber exists, otherwise provide empty string
      const registrationNumber = data.registrationNumber ?? '';
      
      return {
        id: doc.id,
        ...data,
        registrationNumber // This will override any undefined registrationNumber
      };
    });

    console.log("Fetched students:", usersList);
    setStudents(usersList);
  } catch (error) {
    console.error("Error fetching students:", error);
    setStudents([]);
  }
};

// Enhanced handleEditUser with validation
const handleEditUser = (user) => {
  if (!user) return;
  
  // Ensure registrationNumber exists in the editing user
  const userWithRegistration = {
    ...user,
    registrationNumber: user.registrationNumber || ''
  };
  
  setEditingUser(userWithRegistration);
};

// Robust handleUpdateUser
const handleUpdateUser = async () => {
  try {
    if (!editingUser || !editingUser.id) {
      alert("Please select a valid student to edit");
      return;
    }

    // Create update object excluding the document ID
    const { id, ...updateData } = editingUser;
    
    // Ensure registrationNumber is not empty if required
    if (!updateData.registrationNumber?.trim()) {
      alert("Registration number cannot be empty");
      return;
    }

    await updateDoc(doc(db, "users", id), updateData);
    alert("Student updated successfully!");
    setEditingUser(null);
    fetchStudents();
  } catch (error) {
    console.error("Update error:", {
      error,
      editingUser,
      timestamp: new Date().toISOString()
    });
    alert(`Update failed: ${error.message}`);
  }
};

useEffect(() => {
  let isMounted = true;

  const loadData = async () => {
    try {
      await fetchStudents();
      
      if (isMounted) {
        console.log("Student data loaded successfully");
      }
    } catch (error) {
      if (isMounted) {
        console.error("Data loading error:", error);
      }
    }
  };

  loadData();

  return () => {
    isMounted = false;
  };
}, []);




  // Declare searchTerm state variable
  const [searchTerm, setSearchTerm] = useState("");

useEffect(() => {
  if (!searchTerm.trim()) {
    setFilteredStudents(students);
    return;
  }

  const lowerCaseSearch = searchTerm.toLowerCase();
  const filtered = students.filter(student => {
    const fullName = student.fullName || '';
    const regNumber = student.registrationNumber || '';
    
    return (
      fullName.toLowerCase().includes(lowerCaseSearch) ||
      regNumber.toLowerCase().includes(lowerCaseSearch)
    );
  });
  setFilteredStudents(filtered);
}, [searchTerm, students]);




//////////////////////////////////////////// view all assignment ////////////////////////////////////////////


const [studentSubmissions, setStudentSubmissions] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [filters, setFilters] = useState({
  batch: '',
  moduleCode: '',
  viewType: 'all' // 'all', 'assignments', or 'submissions'
});
const [availableBatches, setAvailableBatches] = useState([]);
const [availableModules, setAvailableModules] = useState([]);

// Fetch data from both collections
const fetchAllData = async () => {
  setLoading(true);
  try {
    // Fetch teacher assignments
    const assignmentsSnapshot = await getDocs(collection(db, "assignmentSubmissionDetails"));
    const fetchedAssignments = [];
    
    // Fetch student submissions
    const submissionsSnapshot = await getDocs(collection(db, "assignmentStudentDetails"));
    const fetchedSubmissions = [];
    
    const batches = new Set();
    const modules = new Set();

    // Process teacher assignments
    for (const doc of assignmentsSnapshot.docs) {
      const assignmentData = doc.data();
      batches.add(assignmentData.batch);
      modules.add(assignmentData.moduleCode);

      // Get files from Storage if needed
      const moduleFolderRef = ref(storage, `assignments/${assignmentData.moduleCode}`);
      const filesSnapshot = await listAll(moduleFolderRef);
      const fileLinks = await Promise.all(filesSnapshot.items.map(async (fileRef) => {
        const fileUrl = await getDownloadURL(fileRef);
        return { name: fileRef.name, url: fileUrl };
      }));

      fetchedAssignments.push({
        ...assignmentData,
        id: doc.id,
        type: 'assignment',
        files: fileLinks,
      });
    }



    // Process student submissions

    for (const doc of submissionsSnapshot.docs) {
      const submissionData = doc.data();
      batches.add(submissionData.batch);
      modules.add(submissionData.moduleCode);

      fetchedSubmissions.push({
        ...submissionData,
        id: doc.id,
        type: 'submission',
        files: submissionData.downloadURL ? [{
          name: submissionData.fileName,
          url: submissionData.downloadURL
        }] : []
      });
    }





    /////////////////////////////////////////////////////////
    setAssignments(fetchedAssignments);
    setStudentSubmissions(fetchedSubmissions);
    setAvailableBatches(Array.from(batches));
    setAvailableModules(Array.from(modules));
    applyFilters(fetchedAssignments, fetchedSubmissions);

  } catch (error) {
    console.error("Error fetching data:", error);
    alert("Failed to fetch data.");
  } finally {
    setLoading(false);
  }
};



// Apply filters to both datasets
const applyFilters = (assignmentsData = assignments, submissionsData = studentSubmissions) => {
  let filteredAssignments = [...assignmentsData];
  let filteredSubmissions = [...submissionsData];
  
  // Apply batch filter
  if (filters.batch) {
    filteredAssignments = filteredAssignments.filter(item => item.batch === filters.batch);
    filteredSubmissions = filteredSubmissions.filter(item => item.batch === filters.batch);
  }
  
  // Apply module filter
  if (filters.moduleCode) {
    filteredAssignments = filteredAssignments.filter(item => item.moduleCode === filters.moduleCode);
    filteredSubmissions = filteredSubmissions.filter(item => item.moduleCode === filters.moduleCode);
  }


  if (filters.nameWithInitialFilter) {
    const nameFilterLower = filters.nameWithInitialFilter.toLowerCase();
    filteredAssignments = filteredAssignments.filter(item => 
      item.fullNameWithInitials?.toLowerCase().includes(nameFilterLower));
    filteredSubmissions = filteredSubmissions.filter(item => 
      item.fullNameWithInitials?.toLowerCase().includes(nameFilterLower));
  }

  // Combine based on view type
  let result = [];
  switch (filters.viewType) {
    case 'assignments':
      result = filteredAssignments;
      break;
    case 'submissions':
      result = filteredSubmissions;
      break;
    default:
      result = [...filteredAssignments, ...filteredSubmissions];
  }
  
  setFilteredData(result);
};

const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({
    ...prev,
    [name]: value
  }));
};

const resetFilters = () => {
  setFilters({
    batch: '',
    moduleCode: '',
    viewType: 'all'
  });
  setFilteredData([...assignments, ...studentSubmissions]);
};

useEffect(() => {
  fetchAllData();
}, []);

useEffect(() => {
  applyFilters();
}, [filters, assignments, studentSubmissions]);





















//upload placement assignments

const [selectedFileName, setSelectedFileName] = useState('');
const [noPlacement, setNoPlacement] = useState("");

// Add this missing function
const handleFilePlacementSelect = (e) => {
  const selectedFile = e.target.files[0];
  if (selectedFile && (
      selectedFile.type === 'application/pdf' || 
      selectedFile.name.endsWith('.docx') ||
      selectedFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  )) {
    setFile(selectedFile);
    setSelectedFileName(selectedFile.name);
    setError('');
  } else {
    setFile(null);
    setSelectedFileName('');
    setError('Please select a valid PDF or DOCX file');
  }
};

const uploadPlacementFile = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');
  setSuccess('');

  if (!auth.currentUser) {
    setError('You must be logged in to upload files');
    setLoading(false);
    return;
  }

  if (!batch || !id || !noPlacement || !file) {
    setError('Please fill all fields and select a file');
    setLoading(false);
    return;
  }

  try {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const fileName = `${batch}_${id}_${Date.now()}.${fileExtension}`;
    const storageRef = ref(storage, `placements/${fileName}`);

    const uploadTask = uploadBytesResumable(storageRef, file, {
      customMetadata: {
        uploadedBy: auth.currentUser.uid,
        batch: batch,
        course: id,
        noofPlacement: noPlacement,
        contentType: file.type
      }
    });

    uploadTask.on('state_changed', 
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload progress: ' + progress + '%');
      },
      (error) => {
        throw error;
      }
    );

    const snapshot = await uploadTask;
    const downloadURL = await getDownloadURL(snapshot.ref);

    await addDoc(collection(db, 'placements'), {
      batch,
      course: id,
       noofPlacement: noPlacement,
      fileName,
      fileUrl: downloadURL,
      uploadedBy: auth.currentUser.uid,
      uploaderEmail: auth.currentUser.email,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    setSuccess('Placement assignment uploaded successfully!');
    resetForm();

  } catch (err) {
    console.error('Upload error:', err);
    setError(`Upload failed: ${err.message}`);
  } finally {
    setLoading(false);
  }
};

const resetForm = () => {
  setBatch('');
  setId('');
  setNoPlacement('');
  setFile(null);
  setSelectedFileName('');
  const fileInput = document.getElementById('file-upload');
  if (fileInput) fileInput.value = '';
};
















//   const [nameFilter, setNameFilter] = useState('');
//   const [regNoFilter, setRegNoFilter] = useState('');
//   const [nameWithInitialFilter, setNameWithInitialFilter] = useState('');
//   const [moduleCodeFilter, setModuleCodeFilter] = useState('');
//   const [moduleNameFilter, setModuleNameFilter] = useState('');
//   const [assessmentFilter, setAssessmentFilter] = useState('');

//   // State for results data
//   const [results, setResults] = useState([]);
//   const [filteredResults, setFilteredResults] = useState([]);
  
//   // State for editing
//   const [editingResult, setEditingResult] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);

//   // Fetch all results from Firestore
//   useEffect(() => {
//     const fetchResults = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(db, 'results'));
//         const resultsData = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
//         setResults(resultsData);
//         setFilteredResults(resultsData);
//       } catch (error) {
//         console.error('Error fetching results:', error);
//       }
//     };
    
//     fetchResults();
//   }, []);

//   const uniqueAssessmentTypes = [...new Set(results.map(r => r.typeOfAssesment).filter(Boolean))];



// // Add this state for loading during download
// const [downloading, setDownloading] = useState(false);

// // Add this download function
// const handleDownload = () => {
//   if (filteredResults.length === 0) {
//     alert('No data to download');
//     return;
//   }

//   setDownloading(true);

//   try {
//     // Prepare data for Excel with the required columns
//     const excelData = filteredResults.map(result => ({
//       'Assessment Type': result.typeOfAssesment || 'N/A',
//       'Reg No': result.registrationNumber,
//       'Module Code': result.moduleCode,
//       'Module Name': result.moduleName,
//       'Grade': result.grade,
//       'Remark': result.remark || ''
//     }));

//     // Create workbook and worksheet
//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.json_to_sheet(excelData);

//     // Add worksheet to workbook
//     XLSX.utils.book_append_sheet(wb, ws, 'Filtered Results');

//     // Generate filename with timestamp
//     const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
//     const filename = `filtered_results_${timestamp}.xlsx`;

//     // Download the file
//     XLSX.writeFile(wb, filename);
    
//   } catch (error) {
//     console.error('Error downloading file:', error);
//     alert('Error downloading file. Please try again.');
//   } finally {
//     setDownloading(false);
//   }
// };

// // Add this function to get filter summary for filename (optional)
// const getFilterSummary = () => {
//   const filters = [];
//   if (assessmentFilter) filters.push(`Assessment-${assessmentFilter}`);
//   if (regNoFilter) filters.push(`RegNo-${regNoFilter}`);
//   if (moduleCodeFilter) filters.push(`ModuleCode-${moduleCodeFilter}`);
//   if (moduleNameFilter) filters.push(`ModuleName-${moduleNameFilter}`);
  
//   return filters.length > 0 ? filters.join('_') : 'All';
// };


  const [nameFilter, setNameFilter] = useState('');
  const [regNoFilter, setRegNoFilter] = useState('');
  const [nameWithInitialFilter, setNameWithInitialFilter] = useState('');
  const [moduleCodeFilter, setModuleCodeFilter] = useState('');
  const [moduleNameFilter, setModuleNameFilter] = useState('');
  const [assessmentFilter, setAssessmentFilter] = useState('');

  // ================= DATA STATES =================
  const [results, setResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);

  // ================= EDIT STATES =================
  const [editingResult, setEditingResult] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  // ================= DOWNLOAD STATE =================
  const [downloading, setDownloading] = useState(false);

  // ================= FETCH & SORT DATA =================
  useEffect(() => {
    const fetchResults = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'results'));

        const resultsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // 🔽 SORT BY MODULE CODE (ASCENDING)
        const sortedResults = resultsData.sort((a, b) =>
          (a.moduleCode || '').localeCompare(
            b.moduleCode || '',
            undefined,
            { numeric: true, sensitivity: 'base' }
          )
        );

        setResults(sortedResults);
        setFilteredResults(sortedResults);

      } catch (error) {
        console.error('Error fetching results:', error);
      }
    };

    fetchResults();
  }, []);

  // ================= UNIQUE ASSESSMENTS =================
  const uniqueAssessmentTypes = [
    ...new Set(results.map(r => r.typeOfAssesment).filter(Boolean))
  ];

  // ================= FILTER LOGIC =================
  useEffect(() => {
    let data = [...results];

    if (nameFilter) {
      data = data.filter(r =>
        r.name?.toLowerCase().includes(nameFilter.toLowerCase())
      );
    }

    if (regNoFilter) {
      data = data.filter(r =>
        r.registrationNumber?.toLowerCase().includes(regNoFilter.toLowerCase())
      );
    }

    if (nameWithInitialFilter) {
      data = data.filter(r =>
        r.nameWithInitials?.toLowerCase().includes(nameWithInitialFilter.toLowerCase())
      );
    }

    if (moduleCodeFilter) {
      data = data.filter(r =>
        r.moduleCode?.toLowerCase().includes(moduleCodeFilter.toLowerCase())
      );
    }

    if (moduleNameFilter) {
      data = data.filter(r =>
        r.moduleName?.toLowerCase().includes(moduleNameFilter.toLowerCase())
      );
    }

    if (assessmentFilter) {
      data = data.filter(r => r.typeOfAssesment === assessmentFilter);
    }

    // 🔽 KEEP SORTING AFTER FILTERING
    data.sort((a, b) =>
      (a.moduleCode || '').localeCompare(
        b.moduleCode || '',
        undefined,
        { numeric: true, sensitivity: 'base' }
      )
    );

    setFilteredResults(data);

  }, [
    nameFilter,
    regNoFilter,
    nameWithInitialFilter,
    moduleCodeFilter,
    moduleNameFilter,
    assessmentFilter,
    results
  ]);

  // ================= EXCEL DOWNLOAD =================
  const handleDownload = () => {
    if (filteredResults.length === 0) {
      alert('No data to download');
      return;
    }

    setDownloading(true);

    try {
      // 🔽 SORT BEFORE EXPORT
      const sortedForDownload = [...filteredResults].sort((a, b) =>
        (a.moduleCode || '').localeCompare(
          b.moduleCode || '',
          undefined,
          { numeric: true, sensitivity: 'base' }
        )
      );

      const excelData = sortedForDownload.map(result => ({
        'Assessment Type': result.typeOfAssesment || 'N/A',
        'Reg No': result.registrationNumber,
        'Module Code': result.moduleCode,
        'Module Name': result.moduleName,
        'Grade': result.grade,
        'Remark': result.remark || ''
      }));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Filtered Results');

      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      XLSX.writeFile(wb, `filtered_results_${timestamp}.xlsx`);

    } catch (error) {
      console.error('Download error:', error);
      alert('Error downloading file');
    } finally {
      setDownloading(false);
    }
  };





///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////


const [usersMap, setUsersMap] = useState({});




useEffect(() => {
  const fetchUsers = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'users'));

      const map = {};
      snapshot.forEach(doc => {
        const data = doc.data();
        if (data.registrationNumber) {
          map[data.registrationNumber] = data.fullName || '';
        }
      });

      setUsersMap(map);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  fetchUsers();
}, []);





















useEffect(() => {
  const filtered = results.filter(result => {
    const matchesAssessment =
      assessmentFilter === '' ||
      result.typeOfAssesment === assessmentFilter;

    const matchesRegNo =
      regNoFilter === '' ||
      result.registrationNumber.includes(regNoFilter);

    const matchesModuleCode =
      moduleCodeFilter === '' ||
      result.moduleCode === moduleCodeFilter;

    const matchesModuleName =
      moduleNameFilter === '' ||
      result.moduleName === moduleNameFilter;

    const studentName = usersMap[result.registrationNumber] || '';
    const matchesName =
      nameFilter === '' ||
      studentName.toLowerCase().includes(nameFilter.toLowerCase());

    return (
      matchesAssessment &&
      matchesRegNo &&
      matchesModuleCode &&
      matchesModuleName &&
      matchesName
    );
  });

  setFilteredResults(filtered);
}, [
  assessmentFilter,
  regNoFilter,
  moduleCodeFilter,
  moduleNameFilter,
  nameFilter,
  results,
  usersMap
]);




  // Start editing a result
  const handleEdit = (result) => {
    setEditingResult(result);
    setIsEditing(true);
  };

  // Handle input changes during editing
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingResult(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Save edited result to Firestore
  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'results', editingResult.id), editingResult);
      // Update local state
      setResults(prev => prev.map(r => 
        r.id === editingResult.id ? editingResult : r
      ));
      setIsEditing(false);
      setEditingResult(null);
    } catch (error) {
      console.error('Error updating result:', error);
    }
  };

  // Cancel editing
  const handleCancel = () => {
    setIsEditing(false);
    setEditingResult(null);
  };

  // Get unique module codes for filter dropdown
  const uniqueModuleCodes = [...new Set(results.map(r => r.moduleCode))];
  // Get unique module names for filter dropdown
  const uniqueModuleNames = [...new Set(results.map(r => r.moduleName))];

// Delete a result
const handleDelete = async (resultId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this result?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, 'results', resultId));
    // Update local state after deletion
    setResults(prev => prev.filter(r => r.id !== resultId));
  } catch (error) {
    console.error('Error deleting result:', error);
  }
};







///////////////////////////////////////////// Resultr Overview ////////////////////////////////////////////////////////
//results for continuous assessment  ////////////////////////////////////////////////////////////////////////////////////////////////////////

useEffect(() => {
  const fetchContinuousAssessmentResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Continuous Assessment'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });
      
      setContinuousAssessmentResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "continuouslyAssessmentResults") {
    fetchContinuousAssessmentResults();
  }
}, [selectedOption]);







//results for paractical exam  ////////////////////////////////////////////////////////////////////////////////////////////////////////

useEffect(() => {
  const fetchPracticalExamResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Practical Exam'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });
      
      setPracticalExamResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "practicalExamResults") {
    fetchPracticalExamResults();
  }
}, [selectedOption]);







//results for final Exam  ////////////////////////////////////////////////////////////////////////////////////////////////////////


useEffect(() => {
  const fetchFinalExamResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Final Exam'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });

      // Sort by moduleCode (ascending), then by attemptNo (ascending)
      results.sort((a, b) => {
        const moduleA = a.moduleCode?.toString().toLowerCase() || '';
        const moduleB = b.moduleCode?.toString().toLowerCase() || '';
        if (moduleA < moduleB) return -1;
        if (moduleA > moduleB) return 1;

        // if moduleCode is same, sort by attemptNo as number
        const attemptA = parseInt(a.attemptNo) || 0;
        const attemptB = parseInt(b.attemptNo) || 0;
        return attemptA - attemptB;
      });
      
      setFinalExamResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "finalExamResults") {
    fetchFinalExamResults();
  }
}, [selectedOption])





//results for assignment  ////////////////////////////////////////////////////////////////////////////////////////////////////////

useEffect(() => {
  const fetchContinuousAssessmentResults = async () => {
    try {
      setLoading(true);
      setError('');

      if (!selectedStudent) return;

      const userDoc = await getDoc(doc(db, 'users', selectedStudent));
      if (!userDoc.exists()) throw new Error('Student not found');

      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;

      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Continuous Assessment'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );

      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => results.push(doc.data()));

      setContinuousAssessmentResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "resultOverview" && selectedStudent) {
    fetchContinuousAssessmentResults();
  }
}, [selectedOption, selectedStudent]);







// Helper function to determine program from registration number
const getProgramFromRegNo = (regNo = "") => {
  if (!regNo) return '';
  const prefix = regNo.toString().toUpperCase().substring(0, 2);
  switch (prefix) {
    case 'COO': return 'Certificate in Ophthalmic Optician';
    case 'CO': return 'Certificate in Optician';
    case 'DO': return 'Diploma in Optometry';
    case 'HD': return 'Higher Diploma in Optometry';
    default: return '';
  }
};

// Helper function to get allowed module prefixes for a program
const getAllowedModulePrefixes = (program) => {
  switch (program) {
    case 'COO': return 'Certificate in Ophthalmic Optician';
    case 'Certificate in Optician': return ['CO'];
    case 'Diploma in Optometry': return ['DO'];
    case 'Higher Diploma in Optometry': return ['HD'];
    default: return [];
  }
};

// Helper function to extract numeric part from module code for sorting
const getModuleNumericCode = (moduleCode = "") => {
  const match = moduleCode.toString().match(/\d+/);
  return match ? parseInt(match[0]) : 0;
};

//results for continuous assessment
useEffect(() => {
  const fetchContinuousAssessmentResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      const userProgram = getProgramFromRegNo(registrationNumber);
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Continuous Assessment'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      const allowedPrefixes = getAllowedModulePrefixes(userProgram);
      
      querySnapshot.forEach((doc) => {
        const result = doc.data();
        // Filter results to only include modules that match the user's program
        const modulePrefix = result.moduleCode?.toString().toUpperCase().substring(0, 2);
        if (allowedPrefixes.includes(modulePrefix)) {
          results.push(result);
        }
      });
      
      // Sort by module code in ascending order (101, 102, 103...)
      results.sort((a, b) => {
        const codeA = getModuleNumericCode(a.moduleCode);
        const codeB = getModuleNumericCode(b.moduleCode);
        return codeA - codeB;
      });
      
      setContinuousAssessmentResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "continuouslyAssessmentResults") {
    fetchContinuousAssessmentResults();
  }
}, [selectedOption]);

//results for practical exam
useEffect(() => {
  const fetchPracticalExamResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      const userProgram = getProgramFromRegNo(registrationNumber);
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Practical Exam'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      const allowedPrefixes = getAllowedModulePrefixes(userProgram);
      
      querySnapshot.forEach((doc) => {
        const result = doc.data();
        // Filter results to only include modules that match the user's program
        const modulePrefix = result.moduleCode?.toString().toUpperCase().substring(0, 2);
        if (allowedPrefixes.includes(modulePrefix)) {
          results.push(result);
        }
      });
      
      // Sort by module code in ascending order (101, 102, 103...)
      results.sort((a, b) => {
        const codeA = getModuleNumericCode(a.moduleCode);
        const codeB = getModuleNumericCode(b.moduleCode);
        return codeA - codeB;
      });
      
      setPracticalExamResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "practicalExamResults") {
    fetchPracticalExamResults();
  }
}, [selectedOption]);

//results for final Exam
useEffect(() => {
  const fetchFinalExamResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      const userProgram = getProgramFromRegNo(registrationNumber);
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Final Exam'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      const allowedPrefixes = getAllowedModulePrefixes(userProgram);
      
      querySnapshot.forEach((doc) => {
        const result = doc.data();
        // Filter results to only include modules that match the user's program
        const modulePrefix = result.moduleCode?.toString().toUpperCase().substring(0, 2);
        if (allowedPrefixes.includes(modulePrefix)) {
          results.push(result);
        }
      });

      // Sort by module code (ascending), then by attemptNo (ascending)
      results.sort((a, b) => {
        const codeA = getModuleNumericCode(a.moduleCode);
        const codeB = getModuleNumericCode(b.moduleCode);
        if (codeA !== codeB) return codeA - codeB;

        // if moduleCode is same, sort by attemptNo as number
        const attemptA = parseInt(a.attemptNo) || 0;
        const attemptB = parseInt(b.attemptNo) || 0;
        return attemptA - attemptB;
      });
      
      setFinalExamResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "finalExamResults") {
    fetchFinalExamResults();
  }
}, [selectedOption])

//results for assignment
useEffect(() => {
  const fetchContinuousAssessmentResults = async () => {
    try {
      setLoading(true);
      setError('');

      if (!selectedStudent) return;

      const userDoc = await getDoc(doc(db, 'users', selectedStudent));
      if (!userDoc.exists()) throw new Error('Student not found');

      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      const userProgram = getProgramFromRegNo(registrationNumber);

      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Continuous Assessment'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );

      const querySnapshot = await getDocs(q);
      const results = [];
      const allowedPrefixes = getAllowedModulePrefixes(userProgram);
      
      querySnapshot.forEach((doc) => {
        const result = doc.data();
        // Filter results to only include modules that match the user's program
        const modulePrefix = result.moduleCode?.toString().toUpperCase().substring(0, 2);
        if (allowedPrefixes.includes(modulePrefix)) {
          results.push(result);
        }
      });

      // Sort by module code in ascending order (101, 102, 103...)
      results.sort((a, b) => {
        const codeA = getModuleNumericCode(a.moduleCode);
        const codeB = getModuleNumericCode(b.moduleCode);
        return codeA - codeB;
      });

      setContinuousAssessmentResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "resultOverview" && selectedStudent) {
    fetchContinuousAssessmentResults();
  }
}, [selectedOption, selectedStudent]);

// 🧾 Fetch Students
useEffect(() => {
  const fetchStudents = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"));
      const students = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        // Determine program from registration number if not explicitly set
        const program = data.course || getProgramFromRegNo(data.registrationNumber);
        students.push({
          id: doc.id,
          name: data.fullName || data.name || "Unnamed",
          registrationNumber: data.registrationNumber || "",
          batch: data.batch || "",
          course: program
        });
      });
      setStudentsList(students);
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  };
  fetchStudents();
}, []);







// 📊 Fetch All Results

useEffect(() => {
  const fetchAllResults = async () => {
    try {
      setLoading(true);
      setError("");
      const querySnapshot = await getDocs(collection(db, "results"));
      const results = [];
      querySnapshot.forEach((doc) => results.push(doc.data()));
      setResultsList(results);
    } catch (err) {
      setError("Failed to fetch results: " + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "resultOverview") {
    fetchAllResults();
  }
}, [selectedOption]);

// 🧮 Filter Students
const filteredStudentsOverview = studentsList
  .filter((student) =>
    student.name.toLowerCase().includes(searchName.toLowerCase())
  )
  .filter((student) =>
    student.registrationNumber
      .toLowerCase()
      .includes(searchRegNo.toLowerCase())
  )
  .filter((student) =>
    selectedCourse ? student.course === selectedCourse : true
  )
  .filter((student) => (selectedBatch ? student.batch === selectedBatch : true))
  .sort((a, b) => a.name.localeCompare(b.name));





// 🧮 Get Student's Latest Grade per Module (with program filtering)
const getStudentResultForModule = (studentRegNo, moduleCode, type, studentProgram) => {
  const filtered = resultsList.filter(
    (r) =>
      r.registrationNumber === studentRegNo &&
      r.moduleCode === moduleCode &&
      r.typeOfAssesment === type
  );
  if (filtered.length === 0) return "N/A";

  filtered.sort(
    (a, b) => (parseInt(b.attemptNo) || 0) - (parseInt(a.attemptNo) || 0)
  );
  return filtered[0].grade || "N/A";
};

// 🧾 Get All Modules (Unique) - Filtered by student's program and sorted by module code
const getAllModulesForStudent = (studentProgram) => {
  const modulesMap = {};
  const allowedPrefixes = getAllowedModulePrefixes(studentProgram);
  
  resultsList.forEach((r) => {
    const modulePrefix = r.moduleCode?.toString().toUpperCase().substring(0, 2);
    if (allowedPrefixes.includes(modulePrefix)) {
      if (!modulesMap[r.moduleCode]) {
        modulesMap[r.moduleCode] = {
          moduleName: r.moduleName,
          moduleCode: r.moduleCode
        };
      }
    }
  });
  
  // Convert to array and sort by module code in ascending order
  const modulesArray = Object.values(modulesMap);
  modulesArray.sort((a, b) => {
    const codeA = getModuleNumericCode(a.moduleCode);
    const codeB = getModuleNumericCode(b.moduleCode);
    return codeA - codeB;
  });
  
  return modulesArray;
};







// fetch all submitted assignment brief
// fetch all submitted assignment brief
const [allAssignments, setAllAssignments] = useState([]);
const [filteredAssignments, setFilteredAssignments] = useState([]);
const [loadingAssignments, setLoadingAssignments] = useState(true);

// New state for CO and DO filtered assignments
const [coAssignments, setCoAssignments] = useState([]);
const [doAssignments, setDoAssignments] = useState([]);
const [activeModuleType, setActiveModuleType] = useState('all'); // 'all', 'CO', 'DO'

const [availableCourses, setAvailableCourses] = useState([]);
const [filtersSBrief, setFiltersSBrief] = useState({
  batch: "",
  course: "",
  moduleName: "",
});

// ✅ Fetch Data
useEffect(() => {
  const fetchAssignments = async () => {
    try {
      const snap = await getDocs(collection(db, "assignments"));
      const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setAllAssignments(list);
      
      // Filter assignments based on module type
      filterAssignmentsByType(list, activeModuleType);
      
      setAvailableBatches([...new Set(list.map(a => a.batch))]);

      // ✅ Extract CO / DO / HDO from module codes
      const courses = [...new Set(list.map(a => a.moduleCode?.substring(0,3)))];
      setAvailableCourses(courses.filter(Boolean));

    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      setLoadingAssignments(false);
    }
  };

  if (selectedOption === "viewAlloSubmittedAssignmentBriefs") {
    fetchAssignments();
  }
}, [selectedOption]);

// Helper function to filter assignments by module type
const filterAssignmentsByType = (assignments, type) => {
  if (type === 'CO') {
    const co = assignments.filter(a => a.moduleCode?.startsWith('CO'));
    setCoAssignments(co);
    setFilteredAssignments(co);
  } else if (type === 'DO') {
    const dO = assignments.filter(a => a.moduleCode?.startsWith('DO'));
    setDoAssignments(dO);
    setFilteredAssignments(dO);
  } else {
    setFilteredAssignments(assignments);
  }
};

// ✅ Filtering Function
const handleBriefFilterChange = (e) => {
  const { name, value } = e.target;
  const updated = { ...filtersSBrief, [name]: value };
  setFiltersSBrief(updated);

  // Get base assignments based on active module type
  let baseAssignments = allAssignments;
  if (activeModuleType === 'CO') {
    baseAssignments = allAssignments.filter(a => a.moduleCode?.startsWith('CO'));
  } else if (activeModuleType === 'DO') {
    baseAssignments = allAssignments.filter(a => a.moduleCode?.startsWith('DO'));
  }

  const filtered = baseAssignments.filter(a =>
    (updated.batch === "" || a.batch === updated.batch) &&
    (updated.course === "" || a.moduleCode?.startsWith(updated.course)) &&
    (updated.moduleName === "" ||
      a.moduleName?.toLowerCase().includes(updated.moduleName.toLowerCase()))
  );

  setFilteredAssignments(filtered);
  
  // Also update the respective type-specific state
  if (activeModuleType === 'CO') {
    setCoAssignments(filtered);
  } else if (activeModuleType === 'DO') {
    setDoAssignments(filtered);
  }
};

const resetBriefFilters = () => {
  setFiltersSBrief({ batch: "", course: "", moduleName: "" });
  
  // Reset to show all assignments of current type
  if (activeModuleType === 'CO') {
    const coOnly = allAssignments.filter(a => a.moduleCode?.startsWith('CO'));
    setCoAssignments(coOnly);
    setFilteredAssignments(coOnly);
  } else if (activeModuleType === 'DO') {
    const doOnly = allAssignments.filter(a => a.moduleCode?.startsWith('DO'));
    setDoAssignments(doOnly);
    setFilteredAssignments(doOnly);
  } else {
    setFilteredAssignments(allAssignments);
  }
};

// Handle module type filter
const handleModuleTypeFilter = (type) => {
  setActiveModuleType(type);
  setFiltersSBrief({ batch: "", course: "", moduleName: "" }); // Reset other filters
  
  if (type === 'CO') {
    const coOnly = allAssignments.filter(a => a.moduleCode?.startsWith('CO'));
    setCoAssignments(coOnly);
    setFilteredAssignments(coOnly);
  } else if (type === 'DO') {
    const doOnly = allAssignments.filter(a => a.moduleCode?.startsWith('DO'));
    setDoAssignments(doOnly);
    setFilteredAssignments(doOnly);
  } else {
    setFilteredAssignments(allAssignments);
  }
};

// Helper function to get batch-wise counts
const getBatchWiseCount = (assignments) => {
  return assignments.reduce((acc, curr) => {
    acc[curr.batch] = (acc[curr.batch] || 0) + 1;
    return acc;
  }, {});
};

const handleBriefDelete = async (assignment) => {
  if (!window.confirm("Are you sure you want to delete this assignment?")) return;

  try {
    await deleteDoc(doc(db, "assignments", assignment.id));

    if (assignment.fileUrl) {
      try {
        const decoded = decodeURIComponent(assignment.fileUrl);
        const path = decoded.split("/o/")[1].split("?alt=")[0];
        const fileRef = ref(storage, path);
        await deleteObject(fileRef);
      } catch (e) {
        console.warn("Storage delete skipped:", e);
      }
    }

    const updated = allAssignments.filter(i => i.id !== assignment.id);
    setAllAssignments(updated);
    
    // Update filtered lists based on current active type
    if (activeModuleType === 'CO') {
      const updatedCO = updated.filter(a => a.moduleCode?.startsWith('CO'));
      setCoAssignments(updatedCO);
      setFilteredAssignments(updatedCO);
    } else if (activeModuleType === 'DO') {
      const updatedDO = updated.filter(a => a.moduleCode?.startsWith('DO'));
      setDoAssignments(updatedDO);
      setFilteredAssignments(updatedDO);
    } else {
      setFilteredAssignments(updated);
    }

    setAvailableBatches([...new Set(updated.map(a => a.batch))]);
    setAvailableModules([...new Set(updated.map(a => a.moduleCode))]);

    alert("Assignment deleted ✅");

  } catch (error) {
    console.error("Delete error:", error);
    alert("Delete failed ❌");
  }
};








 const [materials, setMaterials] = useState([]);

  const [moduleSearch, setModuleSearch] = useState("");

  // --- Fetch materials ---
  const fetchMaterials = async () => {
    setLoading(true);
    setError("");
    try {
      const snap = await getDocs(collection(db, "materials"));
      const fetched = snap.docs.map((d) => ({ docId: d.id, ...d.data() }));
      // Normalize fields (some documents may miss fields)
      const normalized = fetched.map((f) => ({
        id: f.docId, // Firestore document id (unique)
        batch: f.batch ?? "",
        course: f.id ?? "", // you stored course earlier as field 'id'
        moduleCode: f.moduleCode ?? "",
        moduleName: f.moduleName ?? "",
        fileUrl: f.fileUrl ?? "",
        fileType: f.fileType ?? "",
        uploadedAt:
          f.uploadedAt && typeof f.uploadedAt.toDate === "function"
            ? f.uploadedAt.toDate()
            : f.uploadedAt ?? null,
      }));
      setMaterials(normalized);
    } catch (err) {
      console.error("fetchMaterials error:", err);
      setError("Failed to load materials.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedOption === "viewLectureMaterials") {
      fetchMaterials();
    }
  }, [selectedOption]);

  // --- Delete material (Firestore doc + Storage object) ---
  const deleteMaterial = async (docId, fileUrl) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;

    setLoading(true);
    setError("");
    try {
      // 1) Delete Firestore document
      await deleteDoc(firestoreDoc(db, "materials", docId));

      // 2) Try deleting storage object
      // Attempt A: treat fileUrl as direct storage path
      try {
        const refA = storageRef(storage, fileUrl);
        await deleteObject(refA);
      } catch (errA) {
        // Attempt B: extract encoded path from download URL (typical firebase storage download URL)
        try {
          const match = fileUrl.match(/\/o\/(.+)\?/); // captures encoded path between /o/ and ?
          if (match && match[1]) {
            const encoded = match[1];
            const decodedPath = decodeURIComponent(encoded);
            const refB = storageRef(storage, decodedPath);
            await deleteObject(refB);
          } else {
            // nothing to delete or nonstandard URL — silently continue
            console.warn("Could not extract storage path from fileUrl:", fileUrl);
          }
        } catch (errB) {
          console.warn("Storage delete fallback failed:", errB);
        }
      }

      // Update local state
      setMaterials((prev) => prev.filter((m) => m.id !== docId));
      alert("Material deleted successfully.");
    } catch (err) {
      console.error("deleteMaterial error:", err);
      setError("Failed to delete material. See console for details.");
    } finally {
      setLoading(false);
    }
  };

  // --- Derived unique filter lists ---
  const uniqueBatchesLec = useMemo(
    () => Array.from(new Set(materials.map((m) => m.batch).filter(Boolean))).sort(),
    [materials]
  );

  const uniqueCourses = useMemo(
    () => Array.from(new Set(materials.map((m) => m.course).filter(Boolean))).sort(),
    [materials]
  );

  // --- Filtered list ---
  const filteredMaterials = useMemo(() => {
    const search = moduleSearch.trim().toLowerCase();
    return materials.filter((item) => {
      const byBatch = !batchFilter || item.batch === batchFilter;
      const byCourse = !courseFilter || item.course === courseFilter;
      const byModule = !search || (item.moduleName || "").toLowerCase().includes(search);
      return byBatch && byCourse && byModule;
    });
  }, [materials, batchFilter, courseFilter, moduleSearch]);



















/////////////////////////////////////////// View all deadline ////////////////////////////////////////////////////////


  // states
  const [deadlines, setDeadlines] = useState([]);


  // helper - format submissionDeadline (handles Firestore Timestamp or Date/string)
  const formatDeadline = (value) => {
    if (!value) return "No date";
    // Firestore Timestamp { seconds, nanoseconds }
    if (value.seconds && typeof value.seconds === "number") {
      return new Date(value.seconds * 1000).toLocaleString();
    }
    // If already a JS Date
    if (value instanceof Date) return value.toLocaleString();
    // Try parseable string
    const parsed = new Date(value);
    if (!isNaN(parsed)) return parsed.toLocaleString();
    return "Invalid date";
  };

  // fetch deadlines - map doc.id to docId and map stored course to course
  const fetchDeadlines = async () => {
    try {
      const q = collection(db, "assignmentSubmissionDetails");
      const querySnapshot = await getDocs(q);

      const data = querySnapshot.docs.map((doc) => {
        const d = doc.data();
        return {
          docId: doc.id,          // <- Firestore document ID (unique)
          course: d.id || "",     // <- the course value you stored in the doc (e.g. "CO")
          batch: d.batch || "",
          moduleName: d.moduleName || "",
          moduleCode: d.moduleCode || "",
          submissionDeadline: d.submissionDeadline || null,
          uploadLink: d.uploadLink || "",
          raw: d,                 // optional for debugging
        };
      });

      console.log("fetched deadlines:", data);
      setDeadlines(data);
    } catch (error) {
      console.error("Error fetching deadlines:", error);
    }
  };

  // delete deadline by Firestore document id (docId)
  const deleteDeadline = async (docId) => {
    if (!docId) {
      alert("Invalid document id. Delete cancelled.");
      console.error("deleteDeadline called with falsy docId:", docId);
      return;
    }

    if (!window.confirm("Are you sure you want to delete this deadline?")) return;

    try {
      await deleteDoc(firestoreDoc(db, "assignmentSubmissionDetails", docId));
      // Update UI without refetching
      setDeadlines((prev) => prev.filter((d) => d.docId !== docId));
      alert("Deadline deleted!");
    } catch (error) {
      console.error("Error deleting deadline:", error);
      alert("Failed to delete deadline.");
    }
  };


  

  // filtered results (use item.course)
  const filteredDeadlines = deadlines.filter((item) => {
    const matchCourse = filterCourse ? item.course === filterCourse : true;
    const matchBatch = filterBatch ? item.batch === filterBatch : true;
    const matchModule = filterModuleName
      ? item.moduleName?.toLowerCase().includes(filterModuleName.toLowerCase())
      : true;

    return matchCourse && matchBatch && matchModule;
  });

  // fetch when tab selected and reset filters when opening
  useEffect(() => {
    if (selectedOption === "viewAllAssignmentDeadline") {
      fetchDeadlines();
      setFilterCourse("");
      setFilterBatch("");
      setFilterModuleName("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);




















  return (
    <div className="admin-container" >

        {/* <div className="admin-container" id="snow-container" >     */}
      
      {/* <div className="santa-container">
        <img src="/santaimg.png" alt="Santa with Reindeer and Cart" className="santa" />
      </div> */}

         <div className="sun-overlay">
            <div className="sun-container">
              <img src="/sun.png" alt="Sun with New Year" className="sun" />
            </div>
          </div>

          {/* <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div> */}



          
      {/* Left-side panel */}
      <div className="admin-sidebar">
        <h2 className="admin-sidebar-title">Admin Panel</h2>
        <ul className="admin-sidebar-list">
          <li onClick={() => setSelectedOption("home")}>Home</li>
          <li onClick={() => setSelectedOption("createAccount")}>Create Users Account</li>


          
          {/* <li onClick={() => setSelectedOption("manageUsers")}>View All Users</li>
          <li onClick={() => setSelectedOption("editUser")}>Edit All Users</li>
          <li onClick={() => setSelectedOption("viewAllUsers")}>Manage Users</li> */}

           <li onClick={toggleUserDropdown} style={{ cursor: "pointer" }}>
              User Management {isUserDropdownOpen ? "▼" : "▶"}
          </li>
          
            {isUserDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("manageUsers")}>View All Users</li>
          <li onClick={() => setSelectedOption("editUser")}>Edit All Users</li>
          <li onClick={() => setSelectedOption("viewAllUsers")}>Manage Users</li>
          </ul>
          )} 

          <li onClick={() => setSelectedOption("studentAttendance")}>Student Attendance</li>
          <li onClick={() => setSelectedOption("paymentDetails")}>Student Payment Details</li>
          <li onClick={() => setSelectedOption("createNotices")}>Create Notices</li>
          <li onClick={() => setSelectedOption("")}>Create Courses Modules</li>


          <li onClick={toggleAssignmentDropdown} style={{ cursor: "pointer" }}>
            Manage Assignments {isAssignmentDropdownOpen ? "▼" : "▶"}
          </li>
          {isAssignmentDropdownOpen && (
          <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("uploadAssignmentBrief")}>Upload Assignment Brief</li>
          <li onClick={() => setSelectedOption("viewAlloSubmittedAssignmentBriefs")}>View All Submitted Assignment Briefs</li> 
          <li onClick={() => setSelectedOption("uploadPlacement")}>Upload Placement Assignment</li>
          <li onClick={() => setSelectedOption("createAssignmentDeadline")}>Create Assignment Deadline Link</li>
              <li onClick={() => setSelectedOption("viewAllAssignmentDeadline")}>View All Deadline Link</li>
          <li onClick={() => setSelectedOption("mitigatetDeadline")}>Assignment Deadline Link - Mitigate</li>
          <li onClick={() => setSelectedOption("viewAssignment")}>View All Submitted Assignments</li>
          </ul>
          )} 



          <li onClick={() => setSelectedOption("updatePayments")}>Update Student Payments</li>
          <li onClick={() => setSelectedOption("outstandingPayments")}>Outstanding Payments</li>



          <li onClick={toggleLectureMaterialDropdown} style={{ cursor: "pointer" }}>
            Manage Lecture Materials {isLectureMaterialDropdownOpen ? "▼" : "▶"}
          </li>
          {isLectureMaterialDropdownOpen && (
          <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("uploadMaterial")}>Upload Lecture Materials</li>
          <li onClick={()=>  setSelectedOption("viewLectureMaterials")}>View All Lecture Materials</li>
         </ul>
          )} 


          <li onClick={() => setSelectedOption("uploadLectureRecordingLink")}>Upload Previous Lecture Recordings</li>
          <li onClick={() => setSelectedOption("uploadStudyMaterialLink")}>Upload Study Material Link</li>
          <li onClick={() => setSelectedOption("uploadQuizMasterLink")}>Upload Quiz Master Link</li>

          {/* {/* <li onClick={() => setSelectedOption("uploadResults")}>Upload Results</li> */}
        



          <li onClick={toggleResultDropdown} style={{ cursor: "pointer" }}>
              Result Management {isResultDropdownOpen ? "▼" : "▶"}
          </li>

            {isResultDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("uploadResults")}>Upload Results</li>
          <li onClick={() => setSelectedOption("updateResults")}>Update Results</li>
          <li onClick={() => setSelectedOption("resultOverview")}>Results OverView</li> 
          
          </ul>
          )} 
          

          <li className="logout-button" onClick={handleLogout}>Logout</li>












        </ul>
      </div>

       {/* Main Panel */}
       <div className="admin-panel">
        {selectedOption === "home" && (
          <div className="home-section">
            <div className="home-content">
              <img
                src="/logo.jpg" // Assuming the image is in the public folder
                alt="Eye Care Institute"
                className="home-image"
              />
              <p className="home-description">
             We are a leading non-state higher education institute, approved by the Ministry of Education and accredited 
             by the Tertiary & Vocational Education Commission (TVEC). Additionally, we are members of the World Council of Optometry (WCO) 
             and the Asia Pacific Council of Optometry (APCO). Our Optician and Optometry courses are recognized by the Ceylon Council of
             Optometrists & Orthoptists (CCOO), Sri Lanka. ECI is the first Sri Lankan private institute to be recognized by the 
             Government of Sri Lanka. We are the only Optometry institute affiliated with a university.
              </p>
            </div>

            <div className="vision-mission">
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                  To be the leader in professional eye care organization by improving the quality and 
                  quantity of the service providers in all eye care segments in the region.
                </p>
              </div>

              <div className="mission">
                <h2>Our Mission</h2>
                <p>
                  Improve the quality of life in the region by integrating, sharing, and enhancing experience and 
                  innovation with professionals involved in eye care.
                </p>
              </div>
            </div>
          </div>
        )}

{/*****************************************************************************************************/}


{selectedOption === "studentAttendance" && (
  <div className="student-profile-second">
    <h1 className="student-panel-title">Student Attendance</h1>
    <p style={{ marginTop: "8px", fontSize: "16px", color: "#555" }}>
      Email: instituteyecare@gmail.com | Password: 123456   
    </p>

    <iframe
      src="https://ec-attendance-system.eyecareinstitute.lk/"
      title="Student Attendance"
      width="100%"
      height="730"
      style={{
        border: "none",
        borderRadius: "12px",
        marginTop: "16px"
      }}
    />
  </div>
)}



{/*****************************************************************************************************/}



{selectedOption === "viewAlloSubmittedAssignmentBriefs" && (
  <div className="student-profile-second">
    <h1 className="student-panel-title">All Submitted Assignment Briefs</h1>

    {/* ✅ MODULE TYPE FILTER BUTTONS */}
    <div className="module-type-filters" style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button 
          onClick={() => handleModuleTypeFilter('all')}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: activeModuleType === 'all' ? '#007bff' : '#f0f0f0',
            color: activeModuleType === 'all' ? 'white' : 'black',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: activeModuleType === 'all' ? 'bold' : 'normal'
          }}
        >
          All Modules ({allAssignments.length})
        </button>
        
        <button 
          onClick={() => handleModuleTypeFilter('CO')}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: activeModuleType === 'CO' ? '#28a745' : '#f0f0f0',
            color: activeModuleType === 'CO' ? 'white' : 'black',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: activeModuleType === 'CO' ? 'bold' : 'normal'
          }}
        >
          CO Modules ({allAssignments.filter(a => a.moduleCode?.startsWith('CO')).length})
        </button>
        
        <button 
          onClick={() => handleModuleTypeFilter('DO')}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: activeModuleType === 'DO' ? '#dc3545' : '#f0f0f0',
            color: activeModuleType === 'DO' ? 'white' : 'black',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: activeModuleType === 'DO' ? 'bold' : 'normal'
          }}
        >
          DO Modules ({allAssignments.filter(a => a.moduleCode?.startsWith('DO')).length})
        </button>
      </div>

      {/* Batch-wise breakdown when CO or DO is selected */}
      {(activeModuleType === 'CO' || activeModuleType === 'DO') && (
        <div style={{ 
          marginTop: '15px', 
          padding: '15px', 
          backgroundColor: '#f8f9fa',
          borderRadius: '4px',
          fontSize: '0.9em'
        }}>
          <strong style={{ display: 'block', marginBottom: '10px' }}>
            Batch-wise distribution for {activeModuleType} modules:
          </strong>
          <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
            {activeModuleType === 'CO' && (
              <>
                {Object.entries(
                  allAssignments
                    .filter(a => a.moduleCode?.startsWith('CO'))
                    .reduce((acc, curr) => {
                      acc[curr.batch] = (acc[curr.batch] || 0) + 1;
                      return acc;
                    }, {})
                ).map(([batch, count]) => (
                  <span key={batch} style={{ 
                    background: '#e9ecef', 
                    padding: '5px 10px', 
                    borderRadius: '4px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px'
                  }}>
                    <span style={{ fontWeight: 'bold' }}>{batch}:</span>
                    <span style={{ 
                      backgroundColor: '#28a745', 
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '12px',
                      fontSize: '0.85em'
                    }}>
                      {count} {count === 1 ? 'assignment' : 'assignments'}
                    </span>
                  </span>
                ))}
              </>
            )}
            
            {activeModuleType === 'DO' && (
              <>
                {Object.entries(
                  allAssignments
                    .filter(a => a.moduleCode?.startsWith('DO'))
                    .reduce((acc, curr) => {
                      acc[curr.batch] = (acc[curr.batch] || 0) + 1;
                      return acc;
                    }, {})
                ).map(([batch, count]) => (
                  <span key={batch} style={{ 
                    background: '#e9ecef', 
                    padding: '5px 10px', 
                    borderRadius: '4px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px'
                  }}>
                    <span style={{ fontWeight: 'bold' }}>{batch}:</span>
                    <span style={{ 
                      backgroundColor: '#dc3545', 
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '12px',
                      fontSize: '0.85em'
                    }}>
                      {count} {count === 1 ? 'assignment' : 'assignments'}
                    </span>
                  </span>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </div>

    {/* ✅ FILTER BAR */}
    <div className="filter-controls">
      {/* Batch Filter */}
      <div className="filter-group">
        <label>Batch:</label>
        <select
          name="batch"
          value={filtersSBrief.batch}
          onChange={handleBriefFilterChange}
        >
          <option value="">All Batches</option>
          {availableBatches.map(batch => (
            <option key={batch} value={batch}>{batch}</option>
          ))}
        </select>
      </div>

      {/* Course Filter (CO / DO / HDO) */}
      <div className="filter-group">
        <label>Course:</label>
        <select
          name="course"
          value={filtersSBrief.course}
          onChange={handleBriefFilterChange}
        >
          <option value="">All Courses</option>
          {availableCourses.map(course => (
            <option key={course} value={course}>{course}</option>
          ))}
        </select>
      </div>

      {/* Module Name Search */}
      <div className="filter-group">
        <label>Module Name:</label>
        <input
          type="text"
          name="moduleName"
          value={filtersSBrief.moduleName}
          placeholder="Search module name..."
          onChange={handleBriefFilterChange}
        />
      </div>

      <button className="reset-btn" onClick={resetBriefFilters}>
        Reset Filters
      </button>
    </div>

    {/* Display current module type info */}
    {activeModuleType !== 'all' && (
      <div style={{ 
        margin: '15px 0', 
        padding: '12px', 
        backgroundColor: activeModuleType === 'CO' ? '#d4edda' : '#f8d7da',
        color: activeModuleType === 'CO' ? '#155724' : '#721c24',
        borderRadius: '4px',
        fontWeight: '500'
      }}>
        <span style={{ fontSize: '1.1em' }}>📊 </span>
        Showing {activeModuleType} Modules Only • {filteredAssignments.length} total {filteredAssignments.length === 1 ? 'assignment' : 'assignments'} found
      </div>
    )}

    {/* ✅ SCROLL TABLE */}
    <div className="table-scroll">
      {loadingAssignments ? (
        <p>Loading assignments...</p>
      ) : filteredAssignments.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          backgroundColor: '#f8f9fa',
          borderRadius: '4px'
        }}>
          <p style={{ fontSize: '1.1em', color: '#666' }}>
            No assignments found for {activeModuleType !== 'all' ? activeModuleType + ' modules' : 'the selected filters'}
          </p>
        </div>
      ) : (
        <table className="assignment-table">
          <thead>
            <tr>
              <th>Batch</th>
              <th>Course Code</th>
              <th>Module Name</th>
              <th>Issue Date</th>
              <th>Submission Date</th>
              <th>View</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssignments.map(a => (
              <tr key={a.id}>
                <td>{a.batch}</td>
                <td>{a.moduleCode}</td>
                <td>{a.moduleName}</td>
                <td>{a.issueDate}</td>
                <td>{a.submissionDate}</td>
                <td>
                  <a 
                    href={a.fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      color: '#007bff',
                      textDecoration: 'none'
                    }}
                  >
                    📄 View PDF
                  </a>
                </td>
                <td>
                  <button 
                    onClick={() => handleBriefDelete(a)}
                    style={{
                      padding: '5px 10px',
                      backgroundColor: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
)}



{/*****************************************************************************************************/}

     {selectedOption === "resultOverview" && (
  <div className="student-profile-second">
    <h1 className="student-panel-title">Results Overview (All Students)</h1>

    {/* 🧭 Filter Bar */}
    <div className="filters-container" style={{ marginBottom: "20px" }}>
      <input
        type="text"
        placeholder="Search by Name"
        value={searchName}
        onChange={(e) => setSearchName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Search by Reg. No"
        value={searchRegNo}
        onChange={(e) => setSearchRegNo(e.target.value)}
      />
      <select
        value={selectedCourse}
        onChange={(e) => setSelectedCourse(e.target.value)}
      >
        <option value="">All Courses</option>
        <option value="Certificate in Ophthalmic Optician">
          Certificate in Ophthalmic Optician
        </option>

        <option value="Certificate in Optician">
          Certificate in Ophthalmic Assistant
        </option>
        <option value="Diploma in Optometry">Diploma in Optometry</option>
        <option value="Higher Diploma in Optometry">
          Higher Diploma in Optometry
        </option>
      </select>
      <select
        value={selectedBatch}
        onChange={(e) => setSelectedBatch(e.target.value)}
      >
        <option value="">All Batches</option>
        <option value="2024-01">2024-01</option>
        <option value="2024-02">2024-02</option>
        <option value="2025-01">2025-01</option>
        <option value="2025-02">2025-02</option>
      </select>
    </div>

    {/* 📊 Results Table */}
    {loading ? (
      <p>Loading results...</p>
    ) : error ? (
      <p className="error">{error}</p>
    ) : (
      <div className="results-table-container">
        {filteredStudentsOverview.length > 0 && resultsList.length > 0 ? (
          <>
            {filteredStudentsOverview.map((student) => {
              const studentProgram = student.course || getProgramFromRegNo(student.registrationNumber);
              const studentModules = getAllModulesForStudent(studentProgram);
              
              return (
                <div key={student.id} className="student-result-block">
                  <h3>
                    {student.name} ({student.registrationNumber})
                  </h3>
                  <p>
                    Course: {studentProgram} | Batch: {student.batch}
                  </p>

                  {studentModules.length > 0 ? (
                    <table className="results-table">
                      <thead>
                        <tr>
                          <th>Module</th>
                          <th>Module Code</th>
                          <th>Assignment</th>
                          <th>Continuous</th>
                          <th>Practical</th>
                          <th>Final</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentModules.map((module) => {
                          const assignment = getStudentResultForModule(
                            student.registrationNumber,
                            module.moduleCode,
                            "Assignment Result",
                            studentProgram
                          );
                          const continuous = getStudentResultForModule(
                            student.registrationNumber,
                            module.moduleCode,
                            "Continuous Assessment",
                            studentProgram
                          );
                          const practical = getStudentResultForModule(
                            student.registrationNumber,
                            module.moduleCode,
                            "Practical Exam",
                            studentProgram
                          );
                          const final = getStudentResultForModule(
                            student.registrationNumber,
                            module.moduleCode,
                            "Final Exam",
                            studentProgram
                          );
                          return (
                            <tr key={module.moduleCode}>
                              <td>{module.moduleName}</td>
                              <td>{module.moduleCode}</td>
                              <td>{assignment === "N/A" ? "-" : assignment}</td>
                              <td>{continuous === "N/A" ? "-" : continuous}</td>
                              <td>{practical === "N/A" ? "-" : practical}</td>
                              <td>{final === "N/A" ? "-" : final}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <p>No modules found for {studentProgram} program.</p>
                  )}
                </div>
              );
            })}
          </>
        ) : (
          <p>No results found.</p>
        )}
      </div>
    )}
  </div>
)}







{/*****************************************************************************************************/}





      {selectedOption === "updateResults" && (
  <div className="result-update-container">
    <h1 className="result-update-title">Student Results Management</h1>
    
    {/* Filter Section */}
    <div className="result-update-filters">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 className="result-update-filters-title">Filters</h2>
        <button 
          className="result-update-download-btn"
          onClick={handleDownload}
          disabled={filteredResults.length === 0 || downloading}
          style={{
            padding: '10px 20px',
            backgroundColor: filteredResults.length === 0 ? '#ccc' : '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: filteredResults.length === 0 ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          {downloading ? 'Downloading...' : `Download (${filteredResults.length} records)`}
        </button>
      </div>
      
      <div className="result-update-filter-row">
        {/* Your existing filter inputs remain the same */}
        <div className="result-update-filter-group">
          <label className="result-update-filter-label">Assessment Type:</label>
          <select
            className="result-update-filter-select"
            value={assessmentFilter}
            onChange={(e) => setAssessmentFilter(e.target.value)}
          >
            <option value="">All Assessment Types</option>
            {uniqueAssessmentTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
        
        <div className="result-update-filter-group">
          <label className="result-update-filter-label">Registration No:</label>
          <input 
            className="result-update-filter-input"
            type="text" 
            value={regNoFilter}
            onChange={(e) => setRegNoFilter(e.target.value)}
            placeholder="Filter by registration number"
          />
        </div>


      <div className="result-update-filter-group">
        <label className="result-update-filter-label">Student Name:</label>
        <input
          className="result-update-filter-input"
          type="text"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
          placeholder="Search by student name"
        />
      </div>

        <div className="result-update-filter-group">
          <label className="result-update-filter-label">Module Name:</label>
          <select
            className="result-update-filter-select"
            value={moduleNameFilter}
            onChange={(e) => setModuleNameFilter(e.target.value)}
          >
            <option value="">All Module Names</option>
            {uniqueModuleNames.map(name => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
        </div>
      </div>
    </div>


      {/* Loading State */}
      {loading ? (
        <div className="result-update-loading">Loading results...</div>
      ) : (
        /* Results Table */
        <div className="result-update-table-container">
          <table className="result-update-table">
            <thead className="result-update-table-head">
              <tr className="result-update-table-row">
                <th className="result-update-table-header">Assesment Type</th>
                <th className="result-update-table-header">Reg No</th>
                <th className="result-update-table-header">Student Name</th>
                <th className="result-update-table-header">Module Code</th>
                <th className="result-update-table-header">Module Name</th>
                <th className="result-update-table-header">Date</th>
                <th className="result-update-table-header">Grade</th>
                <th className="result-update-table-header">Remark</th>
                <th className="result-update-table-header">Actions</th>
              </tr>
            </thead>
            <tbody className="result-update-table-body">
              {filteredResults.length > 0 ? (
                filteredResults.map(result => (
                  <tr key={result.id} className="result-update-table-row">
                    <td className="result-update-table-data">{result.typeOfAssesment || 'N/A'}</td>
                    <td className="result-update-table-data">{result.registrationNumber}</td>
                    <td className="result-update-table-data">{usersMap[result.registrationNumber] || 'N/A'}</td>

                    <td className="result-update-table-data">{result.moduleCode}</td>
                    <td className="result-update-table-data">{result.moduleName}</td>
                    <td className="result-update-table-data">{result.date}</td>
                    <td className="result-update-table-data">{result.grade}</td>
                    <td className="result-update-table-data">{result.remark}</td>

                    <td className="result-update-table-data">
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button 
                          className="result-update-edit-btn"
                          onClick={() => handleEdit(result)}
                        >
                          Edit
                        </button>
                        <button 
                          className="result-update-delete-btn"
                          onClick={() => handleDelete(result.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>

                  </tr>
                ))
              ) : (
                <tr className="result-update-table-row">
                  <td colSpan="7" className="result-update-no-results">
                    {results.length === 0 ? 'No results found' : 'No results match your filters'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      
      {/* Edit Modal */}
      {isEditing && editingResult && (
        <div className="result-update-modal">
          <div className="result-update-modal-content">
            <h2 className="result-update-modal-title">Edit Result</h2>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Registration Number:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="registrationNumber"
                value={editingResult.registrationNumber || ''}
                onChange={handleEditChange}
                disabled
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Module Code:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="moduleCode"
                value={editingResult.moduleCode || ''}
                onChange={handleEditChange}
                required
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Module Name:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="moduleName"
                value={editingResult.moduleName || ''}
                onChange={handleEditChange}
                required
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Grade:</label>
              <select
                className="result-update-form-select"
                name="grade"
                value={editingResult.grade || ''}
                onChange={handleEditChange}
                required
              >
                <option value="">Select Grade</option>
                <option value="A+">A+</option>
                <option value="A">A</option>
                <option value="B+">B+</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="-">-</option>
                <option value="F">F</option>
                <option value="AB">AB</option>
                <option value="N/A">N/A</option>
              </select>
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Remark:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="remark"
                value={editingResult.remark || ''}
                onChange={handleEditChange}
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Attempt No:</label>
              <select
                className="result-update-form-select"
                name="attemptNo"
                value={editingResult.attemptNo || ''}
                onChange={handleEditChange}
                required
              >
                <option value="">Select Attempt</option>
                <option value="1st">1st</option>
                <option value="2nd">2nd</option>
                <option value="3rd">3rd</option>
              </select>
            </div>
            
            <div className="result-update-modal-actions">
              <button type="button" className="result-update-cancel-btn" onClick={handleCancel}>
                Cancel
              </button>
              <button type="button" className="result-update-save-btn" onClick={handleSave}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
)}









       
{selectedOption === "uploadPlacement" && (
  <div className="lecturer-panel-container">
    <h1>Upload Placement Assignments</h1>
    {error && <div className="error-message">{error}</div>}
    {success && <div className="success-message">{success}</div>}
    
    <form onSubmit={uploadPlacementFile}>
      <select
        className="admin-panel-select"
        value={batch}
        onChange={(e) => setBatch(e.target.value)}
        required
      >
        <option value="">Select Batch</option>
        <option value="2022-01">2022-01</option>
        <option value="2023-01">2023-01</option>
        <option value="2024-01">2024-01</option>
        <option value="2024-02">2024-02</option>
        <option value="2025-01">2025-01</option>
        <option value="2025-02">2025-02</option>
        <option value="2026-01">2026-01</option>
        <option value="2026-02">2026-02</option>
        <option value="2027-01">2027-01</option>
        <option value="2027-02">2027-02</option>
        <option value="2028-01">2028-01</option>
        <option value="2028-02">2028-02</option>
        <option value="2029-01">2029-01</option>
        <option value="2029-02">2029-02</option>
        <option value="2030-01">2030-01</option>
        <option value="2030-02">2030-02</option>
        <option value="2031-01">2031-01</option>
        <option value="2031-02">2031-02</option>
        <option value="2032-01">2032-01</option>
        <option value="2032-02">2032-02</option>
        <option value="2033-01">2033-01</option>
        <option value="2033-02">2033-02</option>
        <option value="2034-01">2034-01</option>
        <option value="2034-02">2034-02</option>
        <option value="2035-01">2035-01</option>
        <option value="2035-02">2035-02</option>
      </select>

      <div>
        <label>Course</label>
        <select
          className="admin-panel-select"
          value={id}
          onChange={(e) => setId(e.target.value)}
          required
        >
          <option value="">Select Course</option>
          <option value="COO">Certificate in Ophthalmic Optician</option>
          <option value="CO">Certificate in Ophthalmic Assistant</option>
          <option value="DO">Diploma in Optometry</option>
          <option value="HDO">Higher Diploma in Optometry</option>
        </select>
      </div>

<div>
    <select
        className="admin-panel-select"
        value={noPlacement}
        onChange={(e) => setNoPlacement(e.target.value)}
        required
      >
        <option value="">Number Of Placement</option>
        <option value="01">01</option>
        <option value="02">02</option>
        <option value="03">03</option>
        <option value="04">04</option>
        <option value="05">05</option>
        <option value="06">06</option>
        <option value="07">07</option>
        <option value="08">08</option>
        <option value="09">09</option>
        <option value="10">10</option>
        </select>
</div>




      <div className="upload-section">
        <label className="upload-label">
          {selectedFileName ? selectedFileName : 'Choose PDF/DOCX file'}
        </label>
        <input 
          className="upload-input"
          type="file" 
          onChange={handleFilePlacementSelect} 
          accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          required
          id="file-upload"
        />
        <label htmlFor="file-upload" className="custom-file-upload">
          {selectedFileName ? 'Change File' : 'Select File'}
        </label>
        {selectedFileName && (
          <button 
            type="button" 
            className="clear-file-btn"
            onClick={() => {
              setFile(null);
              setSelectedFileName('');
              document.getElementById('file-upload').value = '';
            }}
          >
            ×
          </button>
        )}
      </div>

      <button className="upload-button" type="submit" disabled={loading}>
        {loading ? "Uploading..." : "Upload Placement Assignment"}
      </button>
    </form>
  </div>
)}









{selectedOption === "viewAssignment" && (
  <div className="lecturer-panel-container">
    <h1>Submitted Assignments</h1>

    <div className="filter-controls">
      <div className="filter-group">
        <label htmlFor="batch-filter">Filter by Batch:</label>
        <select
          id="batch-filter"
          name="batch"
          value={filters.batch}
          onChange={handleFilterChange}
        >
          <option value="">All Batches</option>
          {availableBatches.map(batch => (
            <option key={batch} value={batch}>{batch}</option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label htmlFor="module-filter">Filter by Module:</label>
        <select
          id="module-filter"
          name="moduleCode"
          value={filters.moduleCode}
          onChange={handleFilterChange}
        >
          <option value="">All Modules</option>
          {availableModules.map(module => (
            <option key={module} value={module}>{module}</option>
          ))}
        </select>
      </div>
      

      
      <button onClick={resetFilters} className="reset-btn">
        Reset Filters
      </button>
    </div>

    {loading ? (
      <p>Loading submissions...</p>
    ) : filteredData.length > 0 ? (
      <table className="submission-table">
        <thead>
          <tr>
       
            <th>Batch</th>
            <th>Module Code</th>
            <th>Module Name</th>
            <th>Files</th>
         
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item, index) => (
            <tr key={index} className={`${item.type}-row`}>
   
              <td data-label="Batch">{item.batch}</td>
              <td data-label="Module Code">{item.moduleCode}</td>
              <td data-label="Module Name">{item.moduleName}</td>

              <td data-label="Files">
                {item.files && item.files.length > 0 ? (
                  <ul>
                    {item.files.map((file, idx) => (
                      <li key={idx}>
                        <a
                          href={file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="download-link"
                          download
                        >
                          {file.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No files</p>
                )}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p>No data found matching your filters.</p>
    )}
  </div>
)}










                
             {selectedOption === "editUser" && (
              <>
                <h1 className="admin-panel-title">Edit Student Details</h1>
                <>
    <input
      type="text"
      className="admin-panel-input"
      placeholder="Search by Name or Registration Number"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    
    <ul className="student-list">
      {filteredStudents.map((student) => (
        <li key={student.id}>
          {student.fullName} - {student.registrationNumber || 'No Reg Number'}
          <button className="edit-panel-button" onClick={() => handleEditUser(student)}>
            Edit
          </button>
        </li>
      ))}
    </ul>
  </>
                {editingUser ? (
                  <div className="admin-panel-form">
                        <input
                          type="email"
                          className="admin-panel-input"
                          placeholder="Email"
                          value={editingUser.email || ""}
                          readOnly
                        />

                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="Full Name"
                      value={editingUser.fullName || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, fullName: e.target.value }))
                      }
                    />
                    <input
                      type="text"
                       className="admin-panel-select"
                      placeholder="Registration Number"
                      value={editingUser.registrationNumber || ''}
                      onChange={(e) => setEditingUser(prev => ({
                        ...prev,
                        registrationNumber: e.target.value || null
                      }))}
                    />
                     <select
                      className="admin-panel-select"
                      value={editingUser.program || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, program: e.target.value }))
                      }
                    >
                      <option value="">Select Course</option>
                       <option value="Certificate in Ophthalmic Optician">Certificate in Ophthalmic Optician</option>
                      <option value="Certificate in Optician">Certificate in Ophthalmic Assistant</option>
                      <option value="Diploma in Optometry">Diploma in Optometry</option>
                      <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
                    </select>
                    <select
                      className="admin-panel-select"
                      value={editingUser.courseType || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, courseType: e.target.value }))
                      }
                    >
                      <option value="">Select Course Type</option>
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                    </select>

                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="Course Fee"
                      value={editingUser.courseFee || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, courseFee: e.target.value }))
                      }
                    />

                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="NIC/Passport Number"
                      value={editingUser.nicPassport || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, nicPassport: e.target.value }))
                      }
                    />
                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="Contact Number"
                      value={editingUser.contactNo || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, contactNo: e.target.value }))
                      }
                    />




             <select
              className="admin-panel-select"
              value={editingUser.batch || ""}
              onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, batch: e.target.value }))
              }

              >
              <option value="">Select Batch</option>
              <option value="2022-01">2022-01</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Address"
            value={editingUser.address || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, address: e.target.value }))
            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="First Name"
            value={editingUser.firstName || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, firstName: e.target.value }))
            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Last Name"
            value={editingUser.lastName || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, lastName: e.target.value }))
            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Full Name"
            value={editingUser.fullName || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, fullName: e.target.value }))

            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name with Initial"
            value={editingUser.nameWithInitial || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, nameWithInitial: e.target.value }))
            }
          />

 
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name to be appeared on the certificate"
            value={editingUser.nameToBeAppeared || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, nameToBeAppeared: e.target.value }))

            }
          />



                    <button className="admin-panel-button" onClick={handleUpdateUser}>
                      Save Changes
                    </button>
                    <button
                      className="admin-panel-button"
                      onClick={() => setEditingUser(null)}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div className="editable-student-container">
                  <h2>Select a Student to Edit</h2>
                  <ul className="student-list">
                    {students.map((student) => (
                      <li key={student.id}>
                        {student.fullName} - {student.registrationNumber || 'No Reg Number'}
                        <button
                          className="edit-panel-button"
                          onClick={() => handleEditUser(student)}
                        >
                          Edit
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                )}
              </>
            )} 
















       {selectedOption === "uploadStudyMaterialLink" && (
        <>
          <h1 className="admin-panel-title"> Upload Study Material Link - Google Classroom</h1>
          <div className="upload-quiz-master-link">

            {/* Form for uploading quiz link */}
            <form onSubmit={uploadGoogleClassroomLink}>
              <div>
                <label>Course Type (ID)</label>
                <select
                  className="admin-panel-select"
                  value={courseType}
                  onChange={(e) => setCourseType(e.target.value)}
                  required
                >
                  <option value="">Select Course Type</option>
                  <option value="COO">Certificate in Ophthalmic Optician</option>
                  <option value="CO">Certificate in Ophthalmic Assistant</option>
                  <option value="DO">Diploma in Optometry</option>
                  <option value="HDO">Higher Diploma in Optometry</option>
                </select>
              </div>


  <div>
          <label>Module</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>
           {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}

            {courseType === "CO" && (
              <>
                <option value="" disabled>------ Ophthalmic Assistant Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {courseType === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

              {courseType === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>


  <div className="quiz-link-admin">
    <label>Google Classroom Section's Link</label>
    <input
      type="text"
      value={googleclassroomLink}
      onChange={(e) => setGoogleClassroomLink(e.target.value)}
      placeholder="Paste your link here"

    />
  </div>

  {/* Include File Checkbox */}
  <div style={{ marginTop: "10px" }}>
    <label>
      <input
        type="checkbox"
        checked={includeFile}
        onChange={(e) => setIncludeFile(e.target.checked)}
      />
      &nbsp;Include Study Material File
    </label>
  </div>

  {/* File Input (SHOW ONLY IF CHECKED) */}
  {includeFile && (
<div className="upload-file-container">
  <label>Upload File (PDF / DOCX / XLSX / PPTX)</label>
  <input
    type="file"
    accept=".pdf,.docx,.xlsx,.pptx"
    onChange={(e) => setSelectedFile(e.target.files[0])}
    required={includeFile}
  />
</div>

  )}

  <button className="quiz-generate-button" type="submit">
    Upload
  </button>

</form>

            {/* Display success or error messages */}
            {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
          </div>
        </>
      )}



{/*********************************************************************************************************************/}



{selectedOption === "uploadLectureRecordingLink" && (
  <>
    <h1 className="admin-panel-title">Upload Previous Lecture Recording Link</h1>
    <div className="upload-quiz-master-link">
      <form onSubmit={uploadRecordingLink}>
        <div>
          <label>Course Type (ID)</label>
          <select
            className="admin-panel-select"
            value={courseType}
            onChange={(e) => setCourseType(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="COO">Certificate in Ophthalmic Optician</option>
            <option value="CO">Certificate in Ophthalmic Assistant</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>

        <div>
          <label>Module</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>

           {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}


            {courseType === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {courseType === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

              {courseType === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>

              
          <div>
  <label>Batch</label>
  <select
    className="admin-panel-select"
    value={batch}
    onChange={(e) => setBatch(e.target.value)}
    required
  >
    <option value="">Select Batch</option>
    <option value="2022-01">2022-01</option>
    <option value="2023-01">2023-01</option>
    <option value="2024-01">2024-01</option>
    <option value="2024-02">2024-02</option>
    <option value="2025-01">2025-01</option>
    <option value="2025-02">2025-02</option>
    <option value="2026-01">2026-01</option>
    <option value="2026-02">2026-02</option>
    <option value="2027-01">2027-01</option>
    <option value="2027-02">2027-02</option>
    <option value="2028-01">2028-01</option>
    <option value="2028-02">2028-02</option>
    <option value="2029-01">2029-01</option>
    <option value="2029-02">2029-02</option>
    <option value="2030-01">2030-01</option>
    <option value="2030-02">2030-02</option>
    <option value="2031-01">2031-01</option>
    <option value="2031-02">2031-02</option>
    <option value="2032-01">2032-01</option>
    <option value="2032-02">2032-02</option>
    <option value="2033-01">2033-01</option>
    <option value="2033-02">2033-02</option>
    <option value="2034-01">2034-01</option>
    <option value="2034-02">2034-02</option>
    <option value="2035-01">2035-01</option>
    <option value="2035-02">2035-02</option>
  </select>
</div>



        <div>
          <label>Session No.</label>
          <select
            className="admin-panel-select"
            value={session}
            onChange={(e) => setSession(e.target.value)}
            required
          >
            <option value="">Select Session No</option>
            {[...Array(15)].map((_, index) => (
              <option key={index} value={`Session ${index + 1}`}>
                Session {index + 1}
              </option>
            ))}
          </select>
        </div>



<div>
  <label>Part</label>
  <select
    className="admin-panel-select"
    value={part}
    onChange={(e) => setPart(e.target.value)}
    required
    disabled={!session}   // disables until session is selected
  >
    <option value="">Select Part</option>

    {[...Array(10)].map((_, index) => (
      <option
        key={index}
        value={`Part ${String(index + 1).padStart(2, "0")}`}
      >
        Part {String(index + 1).padStart(2, "0")}
      </option>
    ))}
  </select>
</div>



        <div className="quiz-link-admin">
          <label>Lecture Recording Link</label>
          <input
            type="text"
            value={lectureRecordingLink}
            onChange={(e) => setLectureRecordingLink(e.target.value)}
            placeholder="Paste your link here"
            required
          />
        </div>

        <button className="quiz-generate-button" type="submit">
          Upload Lecture Recording Link
        </button>
      </form>

      {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
    </div>
  </>
)}

















     {selectedOption === "uploadQuizMasterLink" && (
        <>
          <h1 className="admin-panel-title">Upload Quiz Master Link</h1>
          <div className="upload-quiz-master-link">
            {/* Form for uploading quiz link */}
            <form onSubmit={uploadQuizLink}>
              <div>
                <label>Course Type (ID)</label>
                <select
                  className="admin-panel-select"
                  value={courseType}
                  onChange={(e) => setCourseType(e.target.value)}
                  required
                >
                  <option value="">Select Course Type</option>
                  <option value="COO">Certificate in Ophthalmic Optician</option>
                  <option value="CO">Certificate in Ophthalmic Assistant</option>
                  <option value="DO">Diploma in Optometry</option>
                  <option value="HDO">Higher Diploma in Optometry</option>
                </select>
              </div>

              <div>
          <label>Module</label>
          <select
                  className="admin-panel-select"
                  value={moduleName}
                  onChange={(e) => setModuleName(e.target.value)}
                  required
                >
                  <option value="">Select Module</option>

           {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}


                  {courseType === "CO" && (
                    <>
                      <option value="" disabled>------ CO Modules ------</option>
                      <option value="General Science">General Science</option>
                      <option value="Optics">Optics</option>
                      <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                      <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                      <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                      <option value="Common Eye Diseases">Common Eye Diseases</option>
                      <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                      <option value="Understanding Equipment">Understanding Equipment</option>
                      <option value="Sales & Marketing">Sales & Marketing</option>
                    </>
                  )}
                  {courseType === "DO" && (
                    <>
                      <option value="" disabled>------ DO Modules ------</option>
                      <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                      <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                      <option value="Biochemistry">Biochemistry</option>
                      <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                      <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                      <option value="Ocular pathology I">Ocular pathology I</option>
                      <option value="Clinical procedure I">Clinical procedure I</option>
                      <option value="Visual optics">Visual optics</option>
                      <option value="Pharmacology">Pharmacology</option>
                      <option value="Physiology of vision">Physiology of vision</option>
                      <option value="General Medicine">General Medicine</option>
                      <option value="Clinical procedure II">Clinical procedure II</option>
                      <option value="Ocular pathology II">Ocular pathology II</option>
                      <option value="Binocular Vision">Binocular Vision</option>
                      <option value="Contact lens">Contact lens</option>
                      <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                      <option value="Low Vision">Low Vision</option>
                      <option value="Dispensing Optics">Dispensing Optics</option>
                      <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                      <option value="Occupational Optometry">Occupational Optometry</option>
                      <option value="Practice Management">Practice Management</option>
                      <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                    </>
                  )}

                   {courseType === "HDO" && (
                    <>
                      <option value="" disabled>------ DO Modules ------</option>
                      <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                      <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                      <option value="Biochemistry">Biochemistry</option>
                      <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                      <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                      <option value="Ocular pathology I">Ocular pathology I</option>
                      <option value="Clinical procedure I">Clinical procedure I</option>
                      <option value="Visual optics">Visual optics</option>
                      <option value="Pharmacology">Pharmacology</option>
                      <option value="Physiology of vision">Physiology of vision</option>
                      <option value="General Medicine">General Medicine</option>
                      <option value="Clinical procedure II">Clinical procedure II</option>
                      <option value="Ocular pathology II">Ocular pathology II</option>
                      <option value="Binocular Vision">Binocular Vision</option>
                      <option value="Contact lens">Contact lens</option>
                      <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                      <option value="Low Vision">Low Vision</option>
                      <option value="Dispensing Optics">Dispensing Optics</option>
                      <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                      <option value="Occupational Optometry">Occupational Optometry</option>
                      <option value="Practice Management">Practice Management</option>
                      <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                    </>
                  )}


          </select>
        </div>
              



              <div>
                <label>No OF Test</label>
                <select
                  className="admin-panel-select"
                  value={Test}
                  onChange={(e) => setTest(e.target.value)}
                  required
                >
                  <option value="">Select No of Test</option>
                  <option value="Test 01">Test 01</option>
                  <option value="Test 02">Test 02</option>
                  <option value="Test 03">Test 03</option>
                  <option value="Test 04">Test 04</option>                  
                  <option value="Test 05">Test 05</option>                  
                  <option value="Test 06">Test 06</option>                  
                  <option value="Test 07">Test 07</option>                  
                  <option value="Test 08">Test 08</option>                  
                  <option value="Test 09">Test 09</option>                 
                  <option value="Test 10">Test 10</option>                 
                  <option value="Test 11">Test 11</option>                
                  <option value="Test 12">Test 12</option>                 
                  <option value="Test 13">Test 13</option>                  
                  <option value="Test 14">Test 14</option>               
                  <option value="Test 15">Test 15</option>
                </select>
              </div>


              <div className="quiz-link-admin">
                <label>Quiz Link</label>
                <input
                  type="text"
                  value={quizLink}
                  onChange={(e) => setQuizLink(e.target.value)}
                  placeholder="Paste your link here"
                  required
                />
              </div>

              <button className="quiz-generate-button" type="submit">Upload Link</button>
            </form>

            {/* Display success or error messages */}
            {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
          </div>
        </>
      )}



  {/************************************************************************************************************************/}      


{selectedOption === "paymentDetails" && (
  <>
    <h1 className="admin-panel-title">Student Payment Details</h1>

    {/* Search Bar */}
<div className="search-payment">
  <input
    type="text"
    placeholder={`Search by ${searchOption}`}
    value={searchQuery}
    onChange={handleSearchChange}
  />

  <select value={searchOption} onChange={handleSearchOptionChange}>
    <option value="name">Name</option>
    <option value="registrationNumber">Registration Number</option>
  </select>
  

  {/* ✅ Course Filter Dropdown */}
  <select value={courseFilter} onChange={(e) => setCourseFilter(e.target.value)}>
    <option value="">All Courses</option>
    <option value="COO">Certificate in Ophthalmic Optician</option>
    <option value="CO">Certificate in Ophthalmic Assistant</option>
    <option value="DO">Diploma in Optometry</option>
    <option value="HDO">Higher Diploma in Optometry</option>
  </select>



      {/* Batch filter */}
      <select value={batchFilter} onChange={handleBatchFilterChange}>
        <option value="">All Batches</option>
        {availableBatches.map((batch) => (
          <option key={batch} value={batch}>
            {batch}
          </option>
        ))}
      </select>


  <button onClick={downloadPaymentsExcel} className="download-btn">
    Download Payments (Excel)
  </button>
</div>

    {/* Student Payments Table */}
    <div className="table-container">
      <table className="payment-table">
        <thead>
          <tr>
            <th>Student ID</th>
            <th>Student Name</th>
            <th>Total Paid</th>
            <th>Outstanding Amount</th>
            <th>Payment Details</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents && filteredStudents.length > 0 ? (
            filteredStudents.map((student) => (
              <tr key={student.id}>
                <td>{student.registrationNumber || 'N/A'}</td>
                <td>{student.fullName || 'N/A'}</td>
                <td>{student.totalPaid || 0}</td>
                <td>{student.outstandingAmount || 0}</td>
                <td>
                  <ul className="payment-list">
                    {student.payments && student.payments.length > 0 ? (
                      student.payments.map((payment) => (
                        <li key={payment.id} className="payment-item">
                          <div className="payment-info">
                            Receipt No: {payment.receiptNo || 'N/A'}, 
                            Amount: {payment.amount || 0}, 
                            Payment For Month: {payment.paymentForMonth || 'N/A'},
                            Date: {payment.paymentDate?.toDate().toLocaleDateString() || 'N/A'}
                          </div>
                          <button 
                            className="delete-payment-btn"
                            onClick={() => deletePayment(payment.id)}
                          >
                            Delete
                          </button>
                        </li>
                      ))
                    ) : (
                      <li>No payments found</li>
                    )}
                  </ul>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>
                No students found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </>
)}



  {/************************************************************************************************************************/}      



  {selectedOption === "createAccount" && (
    <>
      <h1 className="admin-panel-title">Create User Account</h1>
      <div className="admin-panel-form">
        {/* Input Fields */}
            <input 
            type="email" 
            className="admin-panel-input" 
            placeholder="Email" 
            value={email} onChange={(e) => setEmail(e.target.value)} 
            />
       {/* 
          <input
            type="password"
            className="admin-panel-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /> */}


<div style={{ position: "relative", width: "100%" }}>
  <input
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    style={{
      width: "100%",
      padding: "12px 50px 12px 15px",
      border: "2px solid #ccc",
      borderRadius: "5px",
      outline: "none",
      fontSize: "16px",
      transition: "all 0.3s ease",
      boxShadow: "inset 0 2px 5px rgba(0, 0, 0, 0.1)",
      margin: "0",
      boxSizing: "border-box",
      marginBottom:"15px"
    }}
  />
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      top: "50%",
      right: "15px",
      transform: "translateY(-50%)",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      color: "#aaa",
      transition: "color 0.3s",
      padding: "5px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
  </button>
</div>




          <select
            className="admin-panel-select"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="">Select Role</option>
            <option value="lecturer">Lecturer</option>
            <option value="student">Student</option>
          </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Registration Number"
            value={registrationNumber}
            onChange={(e) => setRegistrationNumber(e.target.value)}
          />
            <select
            className="admin-panel-select"
            value={program}
            onChange={(e) => setProgram(e.target.value)}
          >
            <option value="">Select Course </option>
            <option value="Certificate in Ophthalmic Optician">Certificate in Ophthalmic Optician</option>
            <option value="Certificate in Ophthalmic Assistant">Certificate in Ophthalmic Assistant</option>
            <option value="Diploma in Optometry">Diploma in Optometry</option>
            <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
          </select>

            <select
            className="admin-panel-select"
            value={courseType}
            onChange={(e) => setCourseType(e.target.value)}
          >
            <option value="">Select Course Type</option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
          </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Course Fee"
            value={courseFee}
            onChange={(e) => setCourseFee(e.target.value)}
          />
                     
              <select
              className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2022-01">2022-01</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name with Initial"
            value={nameWithInitial}
            onChange={(e) => setNameWithInitial(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="NIC/Passport Number"
            value={nicPassport}
            onChange={(e) => setNicPassport(e.target.value)}
          />

          <input
            type="tel"
            className="admin-panel-input"
            placeholder="Contact Number"
            value={contactNo}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
              setContactNo(value);
            }}
            maxLength="10"
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name to be appeared on the certificate"
            value={nameToBeAppeared}
            onChange={(e) => setNameToBeAppeared(e.target.value)}
          />
          <button className="admin-panel-button" onClick={createAccount}>
            Create Account
          </button>
          </div>
        </>
      )}



{/************************************************************************************************************************/}      

{selectedOption === "viewAllUsers" && (
  <>
    <h1 className="admin-panel-title">Manage Users</h1>

    {/* 🔎 Search bar */}
    <div className="mb-3">
      <input
        type="text"
        className="form-control"
        placeholder="Search by name "
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>

    <div className="user-list scroll-container">{renderUsersByRole()}</div>
  </>
)}






  {/************************************************************************************************************************/}      



{selectedOption === "manageUsers" && (
  <>
    <h1 className="admin-panel-title">View All Users</h1>

    <div className="summary-section">
      <p>Total Students: {summary.students}</p>
      <p>Total Lecturers: {summary.lecturers}</p>
      <p>Total Admins: {summary.admins}</p>
      <p>Total Sub Admins: {summary.subAdmins}</p>
      <p>Total Users: {summary.total}</p>
    </div>

    <div className="filter-bar">
      <input
        type="text"
        placeholder={`Search by ${searchOption}`}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <select
        value={searchOption}
        onChange={(e) => setSearchOption(e.target.value)}
      >
        <option value="name">Name</option>
        <option value="registrationNumber">Registration Number</option>
      </select>

      <div className="filters">
        {/* Batch Filter */}
        <div className="filter-container">
          <select
            value={batchFilter}
            onChange={(e) => setBatchFilter(e.target.value)}
            className="filter-dropdown"
          >
            <option value="">All Batches</option>
            {uniqueBatches.map((batch) => (
              <option key={batch} value={batch}>
                {batch}
              </option>
            ))}
          </select>
          <span className="filter-count">
            {batchFilter
              ? `Batch ${batchFilter}: ${getFilteredCounts().batchCount}`
              : `All Batches: ${getFilteredCounts().totalFiltered}`}
          </span>
        </div>

        {/* Program Filter */}
        <div className="filter-container">
          <select
            value={programFilter}
            onChange={(e) => setProgramFilter(e.target.value)}
            className="filter-dropdown"
          >
            <option value="">All Programs</option>
            {uniquePrograms.map((program) => (
              <option key={program} value={program}>
                {program}
              </option>
            ))}
          </select>
          <span className="filter-count">
            {programFilter
              ? `Program ${programFilter}: ${getFilteredCounts().programCount}`
              : `All Programs: ${getFilteredCounts().totalFiltered}`}
          </span>
        </div>

        {/* Role Filter */}
        <div className="filter-container">
          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            className="filter-dropdown"
          >
            <option value="">All Roles</option>
            {uniqueRoles.map((role) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button
        onClick={downloadFilteredUsersData}
        className="all-user-download-button"
      >
        Download Filtered Users ({getFilteredCounts().totalFiltered})
      </button>
    </div>

    <div className="user-list scroll-container">
      {renderFilteredUsersTable()}
    </div>
  </>
)}

{/************************************************************************************************************************/}      








{selectedOption === "createNotices" && (
  <div>
    <h1 className="admin-panel-title">Create Notices</h1>
    <div className="admin-panel-form">
      <input
        type="text"
        className="admin-panel-input"
        placeholder="Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <textarea
        className="admin-panel-input"
        placeholder="Notice"
        value={notice}
        onChange={(e) => setNotice(e.target.value)}
        rows="5"
      ></textarea>
      <input
        type="datetime-local"
        className="admin-panel-input"
        value={addedDate}
        onChange={(e) => setAddedDate(e.target.value)}
      />
      
      {/* Image upload checkbox and input */}
      <div className="image-upload-section">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={hasImage}
            onChange={(e) => {
              setHasImage(e.target.checked);
              if (!e.target.checked) {
                setImageFile(null);
                setImageUrl('');
              }
            }}
          />
          Include Image
        </label>
        
        {hasImage && (
          <div className="image-upload-controls">
            <input
              type="file"
              id="notice-image"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files[0]) {
                  setImageFile(e.target.files[0]);
                }
              }}
              disabled={!hasImage}
            />
            {imageFile && (
              <div className="image-preview">
                <p>Selected: {imageFile.name}</p>
              </div>
            )}
          </div>
        )}
      </div>
      
      <button 
        className="admin-panel-button" 
        onClick={createNotice}
        disabled={isUploading}
      >
        {isUploading ? 'Uploading...' : 'Create Notice'}
      </button>
    </div>
  </div>
)}



  {/************************************************************************************************************************/}      

            {selectedOption === "" && (
              <div className="module-form-container">
              <h1>Create Course Module</h1>
              {error && <p className="error-message">{error}</p>}
              {success && <p className="success-message">{success}</p>}
          
              <form onSubmit={handleSubmit} className="module-form">
                <select
                  className="admin-panel-select"
                  name="semester"
                  value={moduleData.semester}
                  onChange={handleChange}
                >
                  <option value="">Select Semester</option>
                  <option value="Y1 S1">Y1 S1</option>
                  <option value="Y1 S2">Y1 S2</option>
                  <option value="Y2 S3">Y2 S3</option>
                  <option value="Y2 S4">Y2 S4</option>
                  <option value="Y3 S5">Y3 S5</option>
                  <option value="-">-</option>
                </select>
          
                <div className="input-group">
                  <label>Module Code</label>
                  <input
                    type="text"
                    name="moduleCode"
                    value={moduleData.moduleCode}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
          
                <div className="input-group">
                  <label>Module Name</label>
                  <input
                    type="text"
                    name="moduleName"
                    value={moduleData.moduleName}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
          
                <div className="input-group">
                  <label>Program Id</label>
                  <input
                    type="text"
                    name="id"
                    placeholder="CO / DO / HDO"
                    value={moduleData.id}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
          
                <button type="submit" disabled={loading} className="submit-button">
                  {loading ? "Creating..." : "Create Module"}
                </button>
              </form>
            </div>
            )}



{/************************************************************************************************************************/}      

{selectedOption === "viewLectureMaterials" && (
  <div className="view-all-lecture-materials-container">
      <h1>View Uploaded Lecture Materials</h1>

      {error && <div style={{ color: "crimson", marginTop: 8 }}>{error}</div>}
      {loading && <div style={{ marginTop: 8 }}>Loading...</div>}

      {/* Filters */}
      <div className="filters-container" style={{ marginTop: 12 }}>
        <select
          className="filter-select"
          value={batchFilter}
          onChange={(e) => setBatchFilter(e.target.value)}
        >
          <option value="">All Batches</option>
          {uniqueBatchesLec.map((b) => (
            <option key={b} value={b}>
              {b}
            </option>
          ))}
        </select>

        <select
          className="filter-select"
          value={courseFilter}
          onChange={(e) => setCourseFilter(e.target.value)}
        >
          <option value="">All Courses</option>
          {/* Show detected courses + fallback options */}
          {uniqueCourses.length > 0
            ? uniqueCourses.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))
            : (
              <>
                <option value="CO">CO</option>
                <option value="COO">COO</option>
                <option value="DO">DO</option>
                <option value="HDO">HDO</option>
              </>
            )}
        </select>

        <input
          type="text"
          className="filter-input"
          placeholder="Search Module Name..."
          value={moduleSearch}
          onChange={(e) => setModuleSearch(e.target.value)}
        />

        <button
          onClick={fetchMaterials}
          style={{
            padding: "8px 12px",
            borderRadius: 6,
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Refresh
        </button>
        <button
          onClick={() => {
            setBatchFilter("");
            setCourseFilter("");
            setModuleSearch("");
          }}
          style={{
            padding: "8px 12px",
            borderRadius: 6,
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
            marginLeft: 6,
          }}
        >
          Clear
        </button>
      </div>

      {/* Table */}
      <div className="table-wrapper" style={{ marginTop: 14 }}>
        <table className="materials-table">
          <thead>
            <tr>
              <th style={{ width: 120 }}>Batch</th>
              <th style={{ width: 120 }}>Course</th>
              <th style={{ width: 140 }}>Module Code</th>
              <th>Module Name</th>
           
              <th style={{ width: 180 }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredMaterials.length > 0 ? (
              filteredMaterials.map((item) => (
                <tr key={item.id}>
                  <td>{item.batch}</td>
                  <td>{item.course}</td>
                  <td>{item.moduleCode}</td>
                  <td>{item.moduleName}</td>
                 
                  <td>
                    <div className="action-buttons">
                      <button
                        className="view-btn"
                        onClick={() => {
                          if (item.fileUrl) window.open(item.fileUrl, "_blank");
                          else alert("No file URL available.");
                        }}
                      >
                        View
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() => deleteMaterial(item.id, item.fileUrl)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: 18 }}>
                  No materials found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Inline CSS (copy to your stylesheet if you prefer) */}
      <style>{`
        .view-all-lecture-materials-container { width: 100%; padding: 18px; background: #f4f7fa; border-radius: 10px; }
        .filters-container { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
        .filter-select, .filter-input { padding: 8px 12px; border-radius: 6px; border: 1px solid #ccc; background: #fff; font-size: 14px; outline: none; }
        .filter-input { min-width: 220px; flex: 1; }
        .table-wrapper { max-height: 480px; overflow-y: auto; margin-top: 12px; border-radius: 10px; border: 1px solid #ddd; background: #fff; }
        .table-wrapper::-webkit-scrollbar { width: 8px; }
        .table-wrapper::-webkit-scrollbar-track { background: #e6e6e6; border-radius: 10px; }
        .table-wrapper::-webkit-scrollbar-thumb { background: #2d3250; border-radius: 10px; }
        table.materials-table { width: 100%; border-collapse: collapse; background: #fff; }
        table.materials-table th { background: #2d3250; color: white; padding: 12px; font-size: 14px; text-align: left; position: sticky; top: 0; z-index: 2; }
        table.materials-table td { padding: 12px; border-bottom: 1px solid #eee; vertical-align: middle; }
        table.materials-table tr:nth-child(even) { background: #fbfbfb; }
        .action-buttons { display: flex; justify-content: flex-start; gap: 8px; width: 170px; }
        .view-btn { background: #0077ff; color: #fff; padding: 8px 10px; border-radius: 6px; border: none; font-size: 13px; cursor: pointer; flex: 1; }
        .view-btn:hover { background: #005fcc; }
        .delete-btn { background: #ff2e2e; color: #fff; padding: 8px 10px; border-radius: 6px; border: none; font-size: 13px; cursor: pointer; flex: 1; }
        .delete-btn:hover { background: #c90000; }
      `}</style>
    </div>
)}

  {/************************************************************************************************************************/}      


            {selectedOption === "uploadMaterial" && (
              <div className="upload-material-container">
                <h1>Upload Lecture Material</h1>

                {/* File upload form */}
                <form onSubmit={uploadFile}>
                <select
              className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
                  <div>
                    <label>Course</label>
                    <select
                    className="admin-panel-select"
                      type="text"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      placeholder="COO / CO / DO / HDO"
                    >
                      <option value="">Select Course</option>
                      <option value="COO">Certificate in Ophthalmic Optician</option>
                      <option value="CO">Certificate in Ophthalmic Assistant</option>
                      <option value="DO">Diploma in Optometry</option>
                      <option value="HDO">Higher Diploma in Optometry</option>
                      </select>
                  </div>



 <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
           {id === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}

            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

            {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>

        <div>
          <label>Module Name</label>
          <input
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          />
          
      
        </div>



                  <div>
                    <label>Choose file</label>
                    <input 
                      type="file" 
                      accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                      onChange={handleFileSelect}
                    />
                  </div>
                  {error && <p>{error}</p>}
                  <button type="submit" disabled={loading}>
                    {loading ? "Uploading..." : "Upload Material"}
                  </button>
                </form>
              </div>
            )}



{/************************************************************************************************************************/}      


            {selectedOption === "createAssignmentDeadline" && (
              <div className="assignment-form-container">
                <h1>Create Assignment Deadline Link</h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleCreateAssignment();
                  }}
                >
      <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            <option value="COO">Certificate in Ophthalmic Optician</option>
            <option value="CO">Certificate in Ophthalmic Assistant</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>


                  <select
                    className="admin-panel-select"
                    value={batch}
                    onChange={(e) => setBatch(e.target.value)}
                    >
                    <option value="">Select Batch</option>
                    <option value="2023-01">2023-01</option>
                    <option value="2024-01">2024-01</option>
                    <option value="2024-02">2024-02</option>
                    <option value="2025-01">2025-01</option>
                    <option value="2025-02">2025-02</option>
                    <option value="2026-01">2026-01</option>
                    <option value="2026-02">2026-02</option>
                    <option value="2027-01">2027-01</option>
                    <option value="2027-02">2027-02</option>
                    <option value="2028-01">2028-01</option>
                    <option value="2028-02">2028-02</option>
                    <option value="2029-01">2029-01</option>
                    <option value="2029-02">2029-02</option>
                    <option value="2030-01">2030-01</option>
                    <option value="2030-02">2030-02</option>
                    <option value="2031-01">2031-01</option>
                    <option value="2031-02">2031-02</option>
                    <option value="2032-01">2032-01</option>
                    <option value="2032-02">2032-02</option>
                    <option value="2033-01">2033-01</option>
                    <option value="2033-02">2033-02</option>
                    <option value="2034-01">2034-01</option>
                    <option value="2034-02">2034-02</option>
                    <option value="2035-01">2035-01</option>
                    <option value="2035-02">2035-02</option>
                  </select>

                

                  <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>

           {id === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="01">Interpret the prescription</option>
                <option value="02">Advice to the customer in selecting a frame</option>
                <option value="03">Select lenses for eyewear</option>
                <option value="04">Take measurements to fix the lenses into the optical frame</option>
                <option value="05">Assess the final product (Eyewear)</option>
                <option value="06">Deliver product & promote sales</option>
                <option value="07">Maintain records & take follow-up action</option>
                <option value="08">Adjust and repair the eyewear</option>
              </>
            )}


            
            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="-">Placement Assesment </option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Placement Assessment - PLC000 </option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="-">Placement Assessment - PLC000 </option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>

              <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>

           {id === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}


            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="Placement Assessment">Placement Assessment</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Frame & Lens">Ophthalmic Frame & Lens</option>
                
                <option value="Ophthalmic Frame & Lens - Frame Display">Ophthalmic Frame & Lens - Frame Display</option>
                <option value="Ophthalmic Frame & Lens - Frame Selection-Booklet  with Cases">Ophthalmic Frame & Lens - Frame Selection-Booklet  with Cases</option>
                <option value="Ophthalmic Frame & Lens - Lens Display ">Ophthalmic Frame & Lens - Lens Display </option>
                <option value="Ophthalmic Frame & Lens - Lens Selection-Booklet  with Cases">Ophthalmic Frame & Lens - Lens Selection-Booklet  with Cases</option>

                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Ophthalmic Equipment - Lensometer">Understanding Ophthalmic Equipment - Lensometer</option>
                <option value="Understanding Ophthalmic Equipment - Visual Acuity">Understanding Ophthalmic Equipment - Visual Acuity</option>
                <option value="Understanding Ophthalmic Equipment - Trial Box">Understanding Ophthalmic Equipment - Trial Box</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Placement Assessment">Placement Assessment</option>
                 <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics - Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

            {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Placement Assessment">Placement Assessment</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics - Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}
          </select>
        </div>


                
                  <div className="form-field">
                    <label>
                      Submission Deadline:
                       <input
                        type="datetime-local"
                        value={submissionDeadline}
                        onChange={(e) => setSubmissionDeadline(e.target.value)}
                        required
                      />
                    </label>
                  </div>
    
                  <button type="submit" disabled={loading}>
                    {loading ? "Creating..." : "Create Assignment Deadline"}
                  </button>
                </form>
              </div>
            )}

{/*******************************  view all assignment deadline ***********************************************/}


 {selectedOption === "viewAllAssignmentDeadline" && (
        <div className="view-all-deadlines-container">
          <h1>View All Assignment Deadlines</h1>

          {/* Filters */}
          <div className="filters-container" style={{ display: "flex", gap: 12, marginBottom: 12 }}>
            <select
              value={filterCourse}
              onChange={(e) => setFilterCourse(e.target.value)}
              className="filter-select"
            >
              <option value="">All Courses</option>
              <option value="COO">Certificate in Ophthalmic Optician (COO)</option>
              <option value="CO">Certificate in Ophthalmic Assistant (CO)</option>
              <option value="DO">Diploma in Optometry (DO)</option>
              <option value="HDO">Higher Diploma in Optometry (HDO)</option>
            </select>

            <select
              value={filterBatch}
              onChange={(e) => setFilterBatch(e.target.value)}
              className="filter-select"
            >
              <option value="">All Batches</option>
              {[...new Set(deadlines.map((d) => d.batch))].map((batch, i) => (
                <option key={i} value={batch}>
                  {batch}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Search Module Name"
              className="filter-input"
              value={filterModuleName}
              onChange={(e) => setFilterModuleName(e.target.value)}
            />
          </div>

          {/* Table */}
          {filteredDeadlines.length === 0 ? (
            <p>No matching deadlines found.</p>
          ) : (
            <div className="table-wrapper" style={{ overflowX: "auto" }}>
              <table className="deadlines-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>Course</th>
                    <th>Batch</th>
                    <th>Module Code</th>
                    <th>Module Name</th>
                    <th>Deadline</th>
                    <th>Upload Link</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDeadlines.map((item) => (
                    <tr key={item.docId}>
                      <td>{item.course}</td>
                      <td>{item.batch}</td>
                      <td>{item.moduleCode}</td>
                      <td>{item.moduleName}</td>
                      <td>{formatDeadline(item.submissionDeadline)}</td>
                      <td style={{ fontSize: 12, maxWidth: 250, overflowWrap: "break-word" }}>
                        {item.uploadLink}
                      </td>
                      <td>
                        <button
                          className="delete-btn"
                          onClick={() => deleteDeadline(item.docId)}
                        >
                          Delete ❌
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}




{/*******************************  assignment deadline for mitigate students ***********************************************/}



{selectedOption === "mitigatetDeadline" && (
              <div className="assignment-form-container">
                <h1>Create Assignment Deadline Link for Mitigate Student</h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleCreateAssignmentForMitigate();
                  }}
                >

      <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="COO">Certificate in Ophthalmic Optician</option>
            <option value="CO">Certificate in Ophthalmic Assistant</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>


                  <div className="form-field">
                    <label>
                      Student Registration No:
                      <input
                        type="text"
                        value={registrationNumber}
                        onChange={(e) => setRegistrationNumber(e.target.value)}
                        required
                      />
                    </label>
                  </div>


                  <select
                    className="admin-panel-select"
                    value={batch}
                    onChange={(e) => setBatch(e.target.value)}
                    >
                    <option value="">Select Batch</option>
                    <option value="2023-01">2023-01</option>
                    <option value="2024-01">2024-01</option>
                    <option value="2024-02">2024-02</option>
                    <option value="2025-01">2025-01</option>
                    <option value="2025-02">2025-02</option>
                    <option value="2026-01">2026-01</option>
                    <option value="2026-02">2026-02</option>
                    <option value="2027-01">2027-01</option>
                    <option value="2027-02">2027-02</option>
                    <option value="2028-01">2028-01</option>
                    <option value="2028-02">2028-02</option>
                    <option value="2029-01">2029-01</option>
                    <option value="2029-02">2029-02</option>
                    <option value="2030-01">2030-01</option>
                    <option value="2030-02">2030-02</option>
                    <option value="2031-01">2031-01</option>
                    <option value="2031-02">2031-02</option>
                    <option value="2032-01">2032-01</option>
                    <option value="2032-02">2032-02</option>
                    <option value="2033-01">2033-01</option>
                    <option value="2033-02">2033-02</option>
                    <option value="2034-01">2034-01</option>
                    <option value="2034-02">2034-02</option>
                    <option value="2035-01">2035-01</option>
                    <option value="2035-02">2035-02</option>
                  </select>




                  <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>


           {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}


            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Ophthalmic Equipment - Lensometer">Understanding Ophthalmic Equipment - Lensometer</option>
                <option value="Understanding Ophthalmic Equipment - Visual Acuity">Understanding Ophthalmic Equipment - Visual Acuity</option>
                <option value="Understanding Ophthalmic Equipment - Trial Box">Understanding Ophthalmic Equipment - Trial Box</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

          </select>
        </div>




        <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>

          {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="01">Interpret the prescription</option>
                <option value="02">Advice to the customer in selecting a frame</option>
                <option value="03">Select lenses for eyewear</option>
                <option value="04">Take measurements to fix the lenses into the optical frame</option>
                <option value="05">Assess the final product (Eyewear)</option>
                <option value="06">Deliver product & promote sales</option>
                <option value="07">Maintain records & take follow-up action</option>
                <option value="08">Adjust and repair the eyewear</option>
              </>
            )}


            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Information Technology</option>
               <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>


                  <div className="form-field">
                    <label>
                      Submission Deadline:
                       <input
                        type="datetime-local"
                        value={submissionDeadline}
                        onChange={(e) => setSubmissionDeadline(e.target.value)}
                        required
                      />
                    </label>
                  </div>
    
                  <button type="submit" disabled={loading}>
                    {loading ? "Creating..." : "Create Assignment Deadline"}
                  </button>
                </form>
              </div>
            )}


{/************************************************************************************************************************/}      





        {selectedOption === "outstandingPayments" && (
          <>
            <h1 className="admin-panel-title">Outstanding Payments</h1>
            <div className="payment-update-container">
              {/* Type of Course Dropdown */}
              <select
                className="admin-panel-select"
                value={courseType}
                onChange={(e) => setCourseType(e.target.value)}
              >
                <option value="">Select Course Type</option>
                <option value="Certificate in Ophthalmic Optician">Certificate in Ophthalmic Optician</option>
                <option value="Certificate in Optician">Certificate in Ophthalmic Assistant</option>
                <option value="Diploma in Optometry">Diploma in Optometry</option>
                <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
              </select>

              {/* Batch Dropdown */}
              <select
                className="admin-panel-select"
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
              >
                <option value="">Select Batch</option>
                {Array.from({ length: 13 }, (_, i) => {
                  const year = 2023 + i;
                  return (
                    <>
                      <option key={`${year}-01`} value={`${year}-01`}>{`${year}-01`}</option>
                      <option key={`${year}-02`} value={`${year}-02`}>{`${year}-02`}</option>
                    </>
                  );
                })}
              </select>

              {/* Submit Button */}
              <button onClick={handlePaymentSubmit} className="submit-btn" disabled={loading}>
                Submit
              </button>

              {/* Clear Button */}
              <button onClick={handleClear} className="clear-btn" disabled={loading}>
                Clear
              </button>
            </div>

            {/* Display Loading Indicator */}
            {loading && (
              <div className="loading-status">
                <p>Loading...</p>  {/* You can replace this with a spinner or any other indicator */}
              </div>
            )}

            {/* Display Total Outstanding Payment */}
            {isSubmitted && !loading && (
              <div className="outstanding-display">
                <h2>Total Outstanding Amount: {outstandingPayments}</h2>
              </div>
            )}
          </>
        )}
        


  {/************************************************************************************************************************/}      







          {selectedOption === "updatePayments" && (
              <div className="payment-update-container">
              <h1>Update Student Payment</h1>
              <form onSubmit={paymentSubmit}>
                <div className="form-group">
                  <label>Student Registration Number</label>
                  <input
                    type="text"
                    name="registrationNumber"
                    value={formData.registrationNumber}
                    onChange={paymentChange}
                    placeholder="Enter Student Registration Number"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Payment Date</label>
                  <input
                    type="date"
                    name="paymentDate"
                    value={formData.paymentDate}
                    onChange={paymentChange}
                    max={new Date().toISOString().split("T")[0]} // Set the max date to today
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Receipt Number</label>
                  <input
                    type="text"
                    name="receiptNo"
                    value={formData.receiptNo}
                    onChange={paymentChange}
                    placeholder="Enter Receipt Number"
                    maxLength="30"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Payment Type</label>
                  <select  className="admin-panel-select"
                    name="paymentType"
                    value={formData.paymentType}
                    onChange={paymentChange}
                    required
                  >
                    <option value="">Select Payment Type</option>
                    <option value="cash">Cash</option>
                    <option value="Online Transaction">Online Transaction</option>
                    <option value="Bank Deposit">Bank Deposit</option>
                    <option value="cheque">Cheque</option>
                    <option value="card">Card</option>
                    <option value="Scholarship">Scholarship</option>
                  </select>
                </div>



<div className="form-group">
  <label>Payment For Month</label>
  <select
    name="paymentForMonth"
    value={formData.paymentForMonth}
    onChange={paymentChange}
    required
  >
    <option value="">Select Month</option>
    <option value="January">January</option>
    <option value="February">February</option>
    <option value="March">March</option>
    <option value="April">April</option>
    <option value="May">May</option>
    <option value="June">June</option>
    <option value="July">July</option>
    <option value="August">August</option>
    <option value="September">September</option>
    <option value="October">October</option>
    <option value="November">November</option>
    <option value="December">December</option>
    <option value="Admission Fee">Admission Fee</option>
  </select>
</div>


                <div className="form-group">
                  <label>Payment Amount</label>
                  <input
                    type="number"
                    name="amount"
                    value={formData.amount}
                    onChange={paymentChange}
                    placeholder="Enter Amount"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Remark</label>
                  <input
                    type="remark"
                    name="remark"
                    value={formData.remark}
                    onChange={paymentChange}
                    placeholder="Remark"
                    required
                  />
                </div>
                <div className="form-buttons">
                  <button type="submit" className="submit-button">
                    Submit
                  </button>
                  <button type="reset" className="cancel-button">
                    Cancel
                  </button>
                </div>
              </form>
              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}
              </div>

            )}





{/************************************************************************************************************************/}      


            {selectedOption === "uploadAssignmentBrief" && (
                  <div className="assignment-form-container">
                    <h1>Upload Assignment Brief</h1>
                    <form onSubmit={uploadAssignmnt}>
                      {/* ID */}
                      <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="COO">Certificate in Ophthalmic Optician</option>
            <option value="CO">Certificate in Ophthalmic Assistant</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>

                      <div className="form-field">
                      <select
                           className="admin-panel-select"
                          value={batch}
                          onChange={(e) => setBatch(e.target.value)}
                          >
                          <option value="">Select Batch</option>
                          <option value="2023-01">2023-01</option>
                          <option value="2024-01">2024-01</option>
                          <option value="2024-02">2024-02</option>
                          <option value="2025-01">2025-01</option>
                          <option value="2025-02">2025-02</option>
                          <option value="2026-01">2026-01</option>
                          <option value="2026-02">2026-02</option>
                          <option value="2027-01">2027-01</option>
                          <option value="2027-02">2027-02</option>
                          <option value="2028-01">2028-01</option>
                          <option value="2028-02">2028-02</option>
                          <option value="2029-01">2029-01</option>
                          <option value="2029-02">2029-02</option>
                          <option value="2030-01">2030-01</option>
                          <option value="2030-02">2030-02</option>
                          <option value="2031-01">2031-01</option>
                          <option value="2031-02">2031-02</option>
                          <option value="2032-01">2032-01</option>
                          <option value="2032-02">2032-02</option>
                          <option value="2033-01">2033-01</option>
                          <option value="2033-02">2033-02</option>
                          <option value="2034-01">2034-01</option>
                          <option value="2034-02">2034-02</option>
                          <option value="2035-01">2035-01</option>
                          <option value="2035-02">2035-02</option>
                        </select>
                        </div>
                 


              <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>

           {id === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}


            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Frame & Lens - Frame Display">Ophthalmic Frame & Lens - Frame Display</option>
                <option value="Ophthalmic Frame & Lens - Frame Selection-Booklet  with Cases">Ophthalmic Frame & Lens - Frame Selection-Booklet  with Cases</option>
                <option value="Ophthalmic Frame & Lens - Lens Display ">Ophthalmic Frame & Lens - Lens Display </option>
                <option value="Ophthalmic Frame & Lens - Lens Selection-Booklet  with Cases">Ophthalmic Frame & Lens - Lens Selection-Booklet  with Cases</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Ophthalmic Equipment - Lensometer">Understanding Ophthalmic Equipment - Lensometer</option>
                <option value="Understanding Ophthalmic Equipment - Visual Acuity">Understanding Ophthalmic Equipment - Visual Acuity</option>
                <option value="Understanding Ophthalmic Equipment - Trial Box">Understanding Ophthalmic Equipment - Trial Box</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}







            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>


        <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>

           {id === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="01">Interpret the prescription</option>
                <option value="02">Advice to the customer in selecting a frame</option>
                <option value="03">Select lenses for eyewear</option>
                <option value="04">Take measurements to fix the lenses into the optical frame</option>
                <option value="05">Assess the final product (Eyewear)</option>
                <option value="06">Deliver product & promote sales</option>
                <option value="07">Maintain records & take follow-up action</option>
                <option value="08">Adjust and repair the eyewear</option>
              </>
            )}



            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}


            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Information Technology</option>
               <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                               <option value="-">Information Technology</option>
               <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>



                      <div className="form-field">
                        <label>
                          Issue Date:
                          <input
                            type="date"
                            value={issueDate}
                            onChange={(e) => setIssueDate(e.target.value)}
                            required
                          />
                        </label>
                      </div>

                
                      <div className="form-field">
                        <label>
                          Submission Date:
                          <input
                            type="date"
                            value={submissionDate}
                            onChange={(e) => setSubmissionDate(e.target.value)}
                            required
                          />
                        </label>
                      </div>

                      <div className="form-field">
                        <label>
                          Upload Assignment Brief (PDF):
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleAssignmentChange}
                            required
                          />
                        </label>
                      </div>

                      {/* Progress Bar */}
                      {uploadProgress > 0 && (
                        <div className="progress-bar-container">
                          <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                            {Math.round(uploadProgress)}%
                          </div>
                        </div>
                      )}

                      {/* Error Message */}
                      {error && <p className="error-message">{error}</p>}

                      {/* Loading Indicator or Submit Button */}
                      <button type="submit" disabled={loading}>
                        {loading ? "Uploading..." : "Upload Assignment"}
                      </button>
                    </form>

                    {/* Success Message */}
                    {success && <p className="success-message">Assignment uploaded successfully!</p>}
                  </div>
                )}

         

  {/************************************************************************************************************************/}      

        {selectedOption === "uploadResults" && ( 
          <div className="upload-results-container">
            <h1>Upload Results</h1>
            <form onSubmit={uploadResults} className="upload-results-form">
            <select
             className="admin-panel-select"
            value={semester}
            onChange={(e) => setSemester(e.target.value)}
          >
            <option value="">Select Semester</option>
            <option value="Y1S1">Y1 S1</option>
            <option value="Y1S2">Y1 S2</option>
            <option value="Y2S3">Y2 S3</option>
            <option value="Y2S4">Y2 S4</option>
          </select>
          



              <div className="input-group">
                <label htmlFor="date">Exam / Assignment Submitted Date</label>
                <input
                  type="date"
                  id="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </div>





            <div>
          <label>Attempt No</label>
          <select
            className="admin-panel-select"
            value={attemptNo}
            onChange={(e) => setAttemptNo(e.target.value)}
            required
          >
            <option value="">Select Attempt No</option>
            <option value="1st">1st</option>
            {/* <option value="2nd">2nd</option>
            <option value="3rd">3rd</option> */}
          </select>
        </div>




          <select
             className="admin-panel-select"
            value={typeOfAssesment}
            onChange={(e) => setTypeOfAssesment(e.target.value)}
          >
            <option value="">Select Type Of Assesment</option>
            <option value="Assignment Result">Assignment Result</option>
            <option value="Continuous Assessment">Continuous Assessment</option>
            <option value="Practical Exam">Practical Exam</option>
            <option value="Final Exam">Final Exam</option>
            {/* <option value="Viva">Viva</option>
            <option value="Practical">Practical</option> */}
          </select>



              <div className="input-group">
                <label htmlFor="registrationNumber">Student Registration No:</label>
                <input
                  type="text"
                  id="registrationNumber"
                  value={registrationNumber}
                  onChange={(e) => setRegistrationNumber(e.target.value)}
                  required
                />
              </div>




            <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={program}
            onChange={(e) => setProgram(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="Certificate in Optician">Certificate in Optician</option>
            <option value="Diploma in Optometry">Diploma in Optometry</option>
            <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
          </select>
        </div>


            <select
               className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
            
        <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>

           {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="01">Interpret the prescription</option>
                <option value="02">Advice to the customer in selecting a frame</option>
                <option value="03">Select lenses for eyewear</option>
                <option value="04">Take measurements to fix the lenses into the optical frame</option>
                <option value="05">Assess the final product (Eyewear)</option>
                <option value="06">Deliver product & promote sales</option>
                <option value="07">Maintain records & take follow-up action</option>
                <option value="08">Adjust and repair the eyewear</option>
              </>
            )}


            {program === "Certificate in Optician" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {program === "Diploma in Optometry" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

             {program === "Higher Diploma in Optometry" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

          </select>
        </div>

        <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>

           {courseType === "COO" && (
              <>
                <option value="" disabled>------ Ophthalmic Optician Modules ------</option>
                <option value="Interpret the prescription">Interpret the prescription</option>
                <option value="Advice to the customer in selecting a frame">Advice to the customer in selecting a frame</option>
                <option value="Select lenses for eyewear">Select lenses for eyewear</option>
                <option value="Take measurements to fix the lenses into the optical frame">Take measurements to fix the lenses into the optical frame</option>
                <option value="Assess the final product (Eyewear)">Assess the final product (Eyewear)</option>
                <option value="Deliver product & promote sales">Deliver product & promote sales</option>
                <option value="Maintain records & take follow-up action">Maintain records & take follow-up action</option>
                <option value="Adjust and repair the eyewear">Adjust and repair the eyewear</option>
              </>
            )}


            {program === "Certificate in Optician" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {program === "Diploma in Optometry" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

             {program === "Higher Diploma in Optometry" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>

              <select
               className="admin-panel-select"
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              >
              <option value="">Select Grade</option>
              <option value="A+">A+</option>
              <option value="A">A</option>
              <option value="B+">B+</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="-">-</option>
              <option value="F">F</option>
              <option value="AB">AB</option>
              <option value="N/A">N/A</option>
            </select>



              <div className="input-group">
                <label htmlFor="remark">Remark:</label>
                <input
                  type="text"
                  id="remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  required
                />
              </div>


              <div className="submit-button-container">
                <button type="submit" disabled={loading}>
                  {loading ? "Uploading..." : "Upload Result"}
                </button>
              </div>
            </form>
          </div>
        )}


      </div>
    </div>
  );
};

export default AdminPanel;
